import React, { useState, useEffect } from "react";
import {
  Table,
  Modal,
  Steps,
  Form,
  Input,
  Progress,
  Tag,
  Tooltip,
  Space,
  Spin,
  Button,
  Row,
  Col,
  InputNumber,
  Select,
  message,
  Popconfirm,
  Drawer,
  Statistic,
  Card,
  Alert,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  MenuFoldOutlined,
  FileSearchOutlined,
  EyeOutlined,
  MenuUnfoldOutlined,
  PlusOutlined,
  DeleteOutlined,
  FileTextOutlined,
  CloseOutlined,
  ClearOutlined,
} from "@ant-design/icons";
import Header166 from "../../../components/header/header";
import "./PlanesCompras.css";
import { getParticipantes } from "../../../services/financiero/plandecompras/getPlandecompras";
import { getPlanesCompra } from "../../../services/financiero/plandecompras/planesdecompra";

import { getProductos } from "../../../services/financiero/productos/getProductos";

import { registrarPlanCompra } from "../../../services/financiero/plandecompras/setPlandecompras";
import { actualizarPlanCompra } from "../../../services/financiero/plandecompras/updatePlandecompras";
import FormatoPlanCompras from "./FormatoPlanCompras"; // 📌 Importa el componente

import ListaDePlantillas from "./FormatoAceptacionCompra/ListaDePlantillas";

import { useSelector } from "react-redux";
import { selectAppPermissions } from "../../../store/auth/selectors";
const estados = [
  {
    value: "sin_registrar",
    label: (
      <>
        <Tag color="default">No registrado</Tag>
      </>
    ),
  },
  {
    value: "registrado_sin_firma",
    label: (
      <>
        <Tag color="orange">Registrado sin firma</Tag>
      </>
    ),
  },
  {
    value: "registrado_con_firma",
    label: (
      <>
        <Tag color="green">Registrado con firma</Tag>
      </>
    ),
  },
];
const PlanesCompras = () => {
  const [planes, setPlanes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [idcurrentPlan, setIdCurrentPlan] = useState(null);

  const [currentStep, setCurrentStep] = useState(0); // Control del paso actual
  const [stepsVisible, setStepsVisible] = useState(true); // Controla la visibilidad del panel de Steps
  const toggleSteps = () => setStepsVisible(!stepsVisible);
  const [participantes, setParticipantes] = useState([]);
  const [productosPAATY, setProductosPAATY] = useState([]);
  const [productosMap, setProductosMap] = useState({});
  const usernameFromState = useSelector((state) => state.auth.user);

  // Estado para controlar el modal y el mensaje de error
  const [isExceeding, setIsExceeding] = useState(false); // Detecta si el presupuesto fue excedido
  const [proyectado, setProyectado] = useState(0); // Calcula el valor proyectado
  const [isModalVisible, setIsModalVisible] = useState(false); // Controla la visibilidad del modal de advertencia
  const [presupuestoasignado, setPresupuestoasignado] = useState([0]);

  const [isModalPreviewOpen, setIsModalPreviewOpen] = useState(false);
  const [selectedFiltersAceptacion, setSelectedFiltersAceptacion] = useState(
    []
  );
  const [selectedFiltersDelegacion, setSelectedFiltersDelegacion] = useState(
    []
  );

  const [
    isModalPreviewOpenFormatoAceptacion,
    setIsModalPreviewOpenFormatoAceptacion,
  ] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const [initialData, setInitialData] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [filteredPlanes, setFilteredPlanes] = useState([]); // Datos filtrados

  const [subtotals, setSubtotals] = useState({
    infraestructura: 0,
    activos: 0,
    herramientas: 0,
    insumos: 0,
    gastos: 0,
    contrapartida: 0,
  });

  const [selectedProductDetails, setSelectedProductDetails] = useState(null);
  const [isModalVisibleP, setIsModalVisibleP] = useState(false);

  const [selectedDepartamento, setSelectedDepartamento] = useState(null);
  const [selectedMunicipio, setSelectedMunicipio] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  //Control de Permisos
  const appName = "planesdecompras";
  const permissions = useSelector((state) =>
    selectAppPermissions(state, appName)
  );
  const permissionUpdate = permissions.priv_update === "Y";
  const permissionInsert = permissions.priv_insert === "Y";
  const permissionExport = permissions.priv_export === "Y";
  const permissionAccess = permissions.priv_access === "Y";

  //Control de Permisos
  const appNameFormatos = "formatos_plan_compras_paati";
  const permissionsFormatos = useSelector((state) =>
    selectAppPermissions(state, appNameFormatos)
  );
  const permissionFormatosAccess = permissionsFormatos.priv_access === "Y";

  // Función para mostrar el modal con los detalles del producto
  const showProductDetails = (product) => {
    setSelectedProductDetails(product);
    setIsModalVisibleP(true);
  };

  // Función para cerrar el modal
  const handleCloseModalP = () => {
    setIsModalVisibleP(false);
  };

  // 📌 Función para abrir el modal con los detalles del plan seleccionado
  const handlePreview = (plan) => {
    setSelectedPlan(plan);
    setIsModalPreviewOpen(true);
  };

  // 📌 Función para cerrar el modal
  const handleClosePreview = () => {
    setIsModalPreviewOpen(false);
    setSelectedPlan(null);
  };

  // Calcula el valor proyectado cada vez que los subtotales cambien
  useEffect(() => {
    const totalProyectado = Object.values(subtotals).reduce(
      (acc, val) => acc + val,
      0
    );
    if (totalProyectado > presupuestoasignado) {
      setIsExceeding(true);
      handleOpenModal();
    } else {
      setIsExceeding(false);
    }
  }, [subtotals, presupuestoasignado]);

  // Función para abrir el modal cuando se detecta un exceso
  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  // Función para cerrar el modal sin cambiar el estado de `isExceeding`
  const handleCloseModal = () => {
    setIsModalVisible(false); // Cierra el modal, pero no cambia isExceeding
  };

  const [form] = Form.useForm();

  const steps = [
    { title: "Código Sir" },
    { title: "A. Infraestructura" },
    { title: "B. Activos Productivos y equipos" },
    { title: "C. Herramientas y Mobiliario" },
    { title: "D. Insumos" },
    { title: "E. Gastos Operativos" },
    { title: "F. Contrapartida" },
    { title: "Concepto de la inversión" },
  ];

  // Función para cargar los datos desde el servicio
  const fetchPlanes = async () => {
    try {
      const response = await getPlanesCompra(); // Llama al servicio
      if (response.status === 200) {
        const processedData = response.data.map((item) => ({
          ...item,
          dataItems:
            typeof item.dataItems === "string"
              ? JSON.parse(item.dataItems)
              : item.dataItems,
          conceptoInversion:
            typeof item.conceptoInversion === "string"
              ? JSON.parse(item.conceptoInversion)
              : item.conceptoInversion,
        }));

        setPlanes(processedData);
      } else {
        console.error(
          "Error al obtener los planes de compra:",
          response.message
        );
      }
    } catch (error) {
      console.error("❌ Error al cargar los planes de compra:", error);
    }
  };

  useEffect(() => {
    fetchPlanes();
  }, []);

  // Esta función recibe un array de códigos SIR
  const fetchParticipantes = async (codSirArray = []) => {
    setLoading(true);
    try {
      // Arma el objeto de parámetros
      // Si el array está vacío, no se asignan a ningún plan -> retorna todos los códigos libres.
      // Si NO está vacío, envía el array para que retorne los códigos libres + los propios
      const params = codSirArray.length
        ? { codigoSirActual: JSON.stringify(codSirArray) }
        : {};

      // Llamar al servicio para obtener los participantes
      const response = await getParticipantes(params);

      if (response && response.status === 200) {
        // Mapear los datos al formato requerido por el <Select>
        const options = response.data.map((item) => ({
          value: item.codigoSir,
          label: `${item.codigoSir} - ${item.nombre}`,
          oid: item.oid, // opcional
        }));

        setParticipantes(options);
      } else {
        console.error(
          "❌ Error al cargar los participantes:",
          response?.message
        );
      }
    } catch (error) {
      console.error(
        "❌ Error al cargar los participantes:",
        error.message || error
      );
    } finally {
      setLoading(false);
    }
  };

  // Cargar los ProductosPAATY desde el servicio

  const fetchProductosPAATY = async () => {
    setLoading(true);
    try {
      const response = await getProductos();
      if (response) {
        const options = response.map((item) => ({
          value: item.oid,
          label: `${item.codigo} - ${item.nombre_producto}`,
          oidUnidadeMedida: item.oid_unidad_medida,
        }));

        const map = response.reduce((acc, item) => {
          acc[item.oid] = item; // Guardar todos los datos del producto
          return acc;
        }, {});

        setProductosPAATY(options);
        setProductosMap(map);
      } else {
        console.error("Error al cargar los productos:", response.message);
      }
    } catch (error) {
      console.error("Error al cargar los productos:", error);
    } finally {
      setLoading(false);
    }
  };

  // Llama a fetchProductosPAATY al montar el componente
  useEffect(() => {
    fetchProductosPAATY();
  }, []);

  useEffect(() => {
    fetchPlanes();
  }, []);

  const handleEdit = async (record) => {
    if (!record || !record.oid) return;

    setCurrentPlan(record);
    setIsModalOpen(true);
    setCurrentStep(0);

    // Guardar una copia del JSON inicial antes de hacer cambios
    setInitialData(JSON.stringify(record));

    // 🔄 Cargar participantes antes de continuar
    const codSirArray = Array.isArray(record.codSir)
      ? record.codSir
      : record.codSir
      ? record.codSir.split(",").map((item) => item.trim())
      : [];
    await fetchParticipantes(codSirArray);

    const safeParse = (data) => {
      if (typeof data === "string") {
        try {
          return JSON.parse(data);
        } catch (error) {
          console.error("❌ Error al parsear JSON:", error);
          return [];
        }
      }
      return data || [];
    };

    const formattedRecord = {
      ...record,
      codSir: codSirArray,
      dataItems: safeParse(record.dataItems),
      conceptoInversion: safeParse(record.conceptoInversion),
    };

    // ✅ Formatear correctamente para el `Select`
    const codSirFormatted = formattedRecord.codSir.map((codigo) => {
      const participante = participantes.find(
        (p) => p.value.trim() === codigo.trim()
      );
      return participante
        ? codigo // 🔥 Solo enviamos el string puro, sin `{ label, value }`
        : codigo;
    });

    form.setFieldsValue({
      codSir: codSirFormatted,
    });

    // 2) Normalizamos cada item en dataItems
    formattedRecord.dataItems.forEach((section) => {
      section.items = (section.items || []).map((item) => ({
        oid: item.oid ?? 0,
        codigo: item.codigo ?? "",
        oid_categoria: item.oid_categoria ?? 0,
        nombreCategoria: item.nombreCategoria ?? "No asignado",
        nombre_producto: item.nombre_producto ?? "",
        descripcion_producto: item.descripcion_producto ?? "",
        oid_unidad_medida: item.oid_unidad_medida ?? 0,
        nombreUnidadMedida: item.nombreUnidadMedida ?? "",
        precio_unitarioPesos: item.precio_unitarioPesos
          ? parseFloat(item.precio_unitarioPesos)
          : 0,
        precio_usd: item.precio_usd ? parseFloat(item.precio_usd) : 0,
        clasificacion: item.clasificacion ?? "",
        simbolo_proyecto: item.simbolo_proyecto ?? "",
        oid_fin_tipoProducto: item.oid_fin_tipoProducto ?? 0,
        nombreTipoProducto: item.nombreTipoProducto ?? "",
        unidad_tecnica: item.unidad_tecnica ?? "",
        estado: item.estado ?? "",
        // estos son los campos que maneja tu Form.List:
        descripcion: item.oidProducto ?? item.oid ?? 0,
        recurso: item.recurso ?? "",
        cantidad: item.cantidad ?? 0,
        unidad: item.nombreUnidadMedida ?? "",
        oid_unidad_medida: item.oid_unidad_medida ?? 0,
        valorUnitario: Number(
          parseFloat(
            item.valorUnitario ?? item.precio_unitarioPesos ?? 0
          ).toFixed(2)
        ),
        valorTotal: Number(parseFloat(item.valorTotal ?? 0).toFixed(2)),
      }));
    });

    // Asignar valores al formulario
    let formValues = {
      codSir: formattedRecord.codSir,
      infraestructura: [],
      activos: [],
      herramientas: [],
      insumos: [],
      gastos: [],
      contrapartida: [],
    };

    const sectionsMap = {
      "A. Infraestructura": "infraestructura",
      "B. Activos Productivos y equipos": "activos",
      "C. Herramientas y Mobiliario": "herramientas",
      "D. Insumos": "insumos",
      "E. Gastos Operativos": "gastos",
      "F. Contrapartida": "contrapartida",
    };

    if (formattedRecord.dataItems && Array.isArray(formattedRecord.dataItems)) {
      formattedRecord.dataItems.forEach((section) => {
        const sectionKey = sectionsMap[section.title];
        if (sectionKey) {
          formValues[sectionKey] = section.items;
        }
      });
    }

    form.setFieldsValue(formValues);

    // Calcular presupuesto

    const presupuesto = codSirArray.length * 3000000;
    setPresupuestoasignado(presupuesto);

    // 🔹 Calcular los subtotales en el momento de carga
    let newSubtotals = {
      infraestructura: 0,
      activos: 0,
      herramientas: 0,
      insumos: 0,
      gastos: 0,
      contrapartida: 0,
    };

    if (formattedRecord.conceptoInversion) {
      formattedRecord.conceptoInversion.forEach((item) => {
        switch (item.concepto) {
          case "A. Infraestructura":
            newSubtotals.infraestructura = item.valor;
            break;
          case "B. Activos Productivos y equipos":
            newSubtotals.activos = item.valor;
            break;
          case "C. Herramientas y Mobiliario":
            newSubtotals.herramientas = item.valor;
            break;
          case "D. Insumos":
            newSubtotals.insumos = item.valor;
            break;
          case "E. Gastos Operativos":
            newSubtotals.gastos = item.valor;
            break;
          case "F. Contrapartida":
            newSubtotals.contrapartida = item.valor;
            break;
          default:
            break;
        }
      });
    }

    setSubtotals(newSubtotals); // ✅ Actualizar subtotales

    // 🔹 Calcular el total proyectado en la carga
    const totalProyectado = Object.values(newSubtotals).reduce(
      (acc, val) => acc + val,
      0
    );
    setProyectado(totalProyectado); // ✅ Fijar el valor de `totalProyectado` en la carga

    form.setFieldsValue({
      codSir: codSirFormatted,
      infraestructura:
        formattedRecord.dataItems.find((i) => i.title === "A. Infraestructura")
          ?.items || [],
      activos:
        formattedRecord.dataItems.find(
          (i) => i.title === "B. Activos Productivos y equipos"
        )?.items || [],
      herramientas:
        formattedRecord.dataItems.find(
          (i) => i.title === "C. Herramientas y Mobiliario"
        )?.items || [],
      insumos:
        formattedRecord.dataItems.find((i) => i.title === "D. Insumos")
          ?.items || [],
      gastos:
        formattedRecord.dataItems.find(
          (i) => i.title === "E. Gastos Operativos"
        )?.items || [],
      contrapartida:
        formattedRecord.dataItems.find((i) => i.title === "F. Contrapartida")
          ?.items || [],
    });
  };

  useEffect(() => {
    if (currentPlan && participantes.length > 0) {
      const codSirArray = Array.isArray(currentPlan.codSir)
        ? currentPlan.codSir
        : currentPlan.codSir
        ? currentPlan.codSir.split(",").map((item) => item.trim())
        : [];

      const codSirFormatted = codSirArray.map((codigo) => {
        const participante = participantes.find(
          (p) => p.value.trim() === codigo.trim()
        );
        return participante
          ? codigo // 🔥 Solo el valor puro
          : codigo;
      });

      form.setFieldsValue({
        codSir: codSirFormatted,
      });
    }
  }, [participantes]);

  const handleCreate = () => {
    setCurrentPlan(null);
    setIsModalOpen(true);
    setCurrentStep(0); // Reinicia al primer paso
    fetchParticipantes();
    setPresupuestoasignado(0); // Reinicia el presupuesto
    form.resetFields();
    setSubtotals({
      infraestructura: 0,
      activos: 0,
      herramientas: 0,
      insumos: 0,
      gastos: 0,
      contrapartida: 0,
    }); // Restablecer subtotales a cero
  };

  // 📌 Calcula la sumatoria de cada concepto
  const totalizarConceptos = (data) => {
    const totals = {
      infraestructura: 0,
      activos: 0,
      herramientas: 0,
      insumos: 0,
      gastos: 0,
      contrapartida: 0,
      total: 0,
    };

    data.forEach((plan) => {
      plan.conceptoInversion.forEach((concepto) => {
        switch (concepto.concepto) {
          case "A. Infraestructura":
            totals.infraestructura += concepto.valor;
            break;
          case "B. Activos Productivos y equipos":
            totals.activos += concepto.valor;
            break;
          case "C. Herramientas y Mobiliario":
            totals.herramientas += concepto.valor;
            break;
          case "D. Insumos":
            totals.insumos += concepto.valor;
            break;
          case "E. Gastos Operativos":
            totals.gastos += concepto.valor;
            break;
          case "F. Contrapartida":
            totals.contrapartida += concepto.valor;
            break;
          case "TOTAL PROYECTO":
            totals.total += concepto.valor;
            break;
          default:
            break;
        }
      });
    });

    return totals;
  };

  // 📌 Obtiene los totales calculados
  const totals = totalizarConceptos(planes);

  // Funcion para poder habilitar modal con los formatos
  const handleDiligenciarClick = (record) => {
    setIsModalPreviewOpenFormatoAceptacion(true);
    setIdCurrentPlan(record.oid);
  };
  const columns = [
    {
      title: "Acciones",
      key: "acciones",
      width: 180,
      align: "center",
      render: (_, record) => (
        <Space>
          {permissionAccess && (
            <Tooltip title="Ver">
              <Button
                type="primary"
                icon={<EyeOutlined />}
                onClick={() => handlePreview(record)}
              />
            </Tooltip>
          )}

          {permissionUpdate && (
            <Tooltip title="Editar">
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />
            </Tooltip>
          )}

          {permissionExport && (
            <Tooltip title="Exportar a Excel">
              <FormatoPlanCompras plan={record} />
            </Tooltip>
          )}

          {permissionFormatosAccess && (
            <Tooltip title="Documentos">
              <Button
                type="primary"
                icon={<FileTextOutlined />}
                onClick={() => handleDiligenciarClick(record)}
              />
            </Tooltip>
          )}
        </Space>
      ),
    },

    {
      title: "Formato aceptación",
      key: "formato_aceptacion",
      align: "center",
      render: (_, record) => {
        if (record.tiene_aceptacion === 0) {
          return <Tag color="default">No registrado</Tag>;
        }

        if (record.estado_aceptacion === 0) {
          return <Tag color="orange">Registrado sin firma</Tag>;
        }

        if (record.estado_aceptacion === 1) {
          return <Tag color="green">Registrado con firma</Tag>;
        }

        return null;
      },
    },
    {
      title: "Formato delegación",
      key: "formato_delegacion",
      align: "center",
      width: 200, // 🔹 Define un ancho fijo
      render: (_, record) => {
        if (record.tiene_delegacion === 0) {
          return <Tag color="default">No registrado</Tag>;
        }

        if (record.estado_delegacion === 0) {
          return <Tag color="orange">Registrado sin firma</Tag>;
        }

        if (record.estado_delegacion === 1) {
          return <Tag color="green">Registrado con firma</Tag>;
        }

        return null; // En caso de datos inconsistentes
      },
    },

    {
      title: "Código SIR",
      dataIndex: "codSir",
      key: "codSir",
      width: 120, // 🔹 Define un ancho fijo
      render: (text) => {
        // Si el texto tiene más de 10 caracteres, lo recorta y añade '...'
        const isLong = text.length > 50;
        const displayText = isLong ? `${text.substring(0, 50)}...` : text;

        return (
          <Tooltip title={text}>
            <span>{displayText}</span>
          </Tooltip>
        );
      },
    },

    {
      title: "Nombres",
      dataIndex: "nombres_if",
      width: 200,
      render: (text) => {
        // Si el texto tiene más de 10 caracteres, lo recorta y añade '...'
        const isLong = text.length > 50;
        const displayText = isLong ? `${text.substring(0, 50)}...` : text;

        return (
          <Tooltip title={text}>
            <span>{displayText}</span>
          </Tooltip>
        );
      },
      key: "nombres_if",
    },

    {
      title: "Departamento",
      dataIndex: "departamento",
      key: "departamento",
      width: 150, // 🔹 Define un ancho fijo
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      key: "municipio",
      width: 150, // 🔹 Define un ancho fijo
    },

    {
      title: "Total Proyecto",
      dataIndex: "conceptoInversion",
      key: "total",
      align: "right",
      width: 150, // 🔹 Define un ancho fijo

      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "TOTAL PROYECTO"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
              style: "currency",
              currency: "COP",
            })
          : "-";
      },
    },
    {
      title: "Usuario",
      dataIndex: "user",
      key: "user",
      width: 100, // 🔹 Define un ancho fijo
    },
    {
      title: "A. Infraestructura",
      dataIndex: "conceptoInversion",
      key: "infraestructura",
      align: "right",
      width: 200, // 🔹 Define un ancho fijo
      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "A. Infraestructura"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
              style: "currency",
              currency: "COP",
            })
          : "-";
      },
    },
    {
      title: "B. Activos Productivos y equipos",
      dataIndex: "conceptoInversion",
      key: "activos",
      align: "right",
      width: 200, // 🔹 Define un ancho fijo

      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "B. Activos Productivos y equipos"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
              style: "currency",
              currency: "COP",
            })
          : "-";
      },
    },
    {
      title: "C. Herramientas y Mobiliario",
      dataIndex: "conceptoInversion",
      key: "herramientas",
      align: "right",
      width: 200, // 🔹 Define un ancho fijo

      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "C. Herramientas y Mobiliario"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
              style: "currency",
              currency: "COP",
            })
          : "-";
      },
    },
    {
      title: "D. Insumos",
      dataIndex: "conceptoInversion",
      key: "insumos",
      align: "right",
      width: 200, // 🔹 Define un ancho fijo

      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "D. Insumos"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
              style: "currency",
              currency: "COP",
            })
          : "-";
      },
    },
    {
      title: "E. Gastos Operativos",
      dataIndex: "conceptoInversion",
      key: "gastos",
      align: "right",
      width: 200, // 🔹 Define un ancho fijo

      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "E. Gastos Operativos"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
              style: "currency",
              currency: "COP",
            })
          : "-";
      },
    },
    {
      title: "F. Contrapartida",
      dataIndex: "conceptoInversion",
      key: "contrapartida",
      align: "right",
      width: 200, // 🔹 Define un ancho fijo

      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "F. Contrapartida"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
              style: "currency",
              currency: "COP",
            })
          : "-";
      },
    },

    {
      title: "Fecha Creación",
      dataIndex: "fecha_creacion",
      key: "fecha_creacion",
      align: "center",
      width: 200, // 🔹 Define un ancho fijo

      render: (fecha) =>
        new Date(fecha).toLocaleDateString("es-CO", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
    },
    {
      title: "Última Actualización",
      dataIndex: "fecha_actualizacion",
      key: "fecha_actualizacion",
      align: "center",
      width: 200, // 🔹 Define un ancho fijo

      render: (fecha) =>
        new Date(fecha).toLocaleDateString("es-CO", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
    },
  ];

  const next = () => {
    if (currentStep === 0) {
      form
        .validateFields(["codSir", "cofinanciacion", "contrapartida"])
        .then(() => {
          setCurrentStep((prev) => prev + 1);
        })
        .catch((errorInfo) => {
          console.error("Error en los campos del paso 0:", errorInfo);
        });
    } else if (currentStep === 1) {
      if (validateFormListFields("infraestructura")) {
        setCurrentStep((prev) => prev + 1);
      }
    } else if (currentStep === 2) {
      if (validateFormListFields("activos")) {
        setCurrentStep((prev) => prev + 1);
      }
    } else if (currentStep === 3) {
      if (validateFormListFields("herramientas")) {
        setCurrentStep((prev) => prev + 1);
      }
    } else if (currentStep === 4) {
      if (validateFormListFields("insumos")) {
        setCurrentStep((prev) => prev + 1);
      }
    } else if (currentStep === 5) {
      if (validateFormListFields("gastos")) {
        setCurrentStep((prev) => prev + 1);
      }
    } else if (currentStep === 6) {
      if (validateFormListFields("contrapartida")) {
        setCurrentStep((prev) => prev + 1);
      }
    } else {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const prev = () => {
    if (currentStep === 6 && !validateFormListFields("contrapartida")) {
      message.error(
        "Complete los campos de Contrapartida antes de retroceder."
      );
      return;
    } else if (currentStep === 5 && !validateFormListFields("gastos")) {
      message.error("Complete los campos de Gastos antes de retroceder.");
      return;
    } else if (currentStep === 4 && !validateFormListFields("insumos")) {
      message.error("Complete los campos de Insumos antes de retroceder.");
      return;
    } else if (currentStep === 3 && !validateFormListFields("herramientas")) {
      message.error("Complete los campos de Herramientas antes de retroceder.");
      return;
    } else if (currentStep === 2 && !validateFormListFields("activos")) {
      message.error(
        "Complete los campos de Activos Productivos antes de retroceder."
      );
      return;
    } else if (
      currentStep === 1 &&
      !validateFormListFields("infraestructura")
    ) {
      message.error(
        "Complete los campos de Infraestructura antes de retroceder."
      );
      return;
    }

    // Solo retrocede si no hubo errores en los pasos anteriores
    setCurrentStep((prev) => prev - 1);
  };

  const handleStepChange = (nextStep) => {
    // Valida los campos según el paso actual

    if (nextStep === steps.length - 1 && isExceeding) {
      // Previene avanzar al último paso si hay error
      return;
    }

    if (currentStep === 0) {
      form
        .validateFields(["codSir", "cofinanciacion", "contrapartida"])
        .then(() => {
          setCurrentStep(nextStep);
        })
        .catch(() => {
          message.error(
            "Debe diligenciar todos los campos requeridos en el paso 0 antes de continuar."
          );
        });
    } else if (currentStep === 1) {
      if (validateFormListFields("infraestructura")) {
        setCurrentStep(nextStep);
      }
    } else if (currentStep === 2) {
      if (validateFormListFields("activos")) {
        setCurrentStep(nextStep);
      }
    } else if (currentStep === 3) {
      if (validateFormListFields("herramientas")) {
        setCurrentStep(nextStep);
      }
    } else if (currentStep === 4) {
      if (validateFormListFields("insumos")) {
        setCurrentStep(nextStep);
      }
    } else if (currentStep === 5) {
      if (validateFormListFields("gastos")) {
        setCurrentStep(nextStep);
      }
    } else if (currentStep === 6) {
      if (validateFormListFields("contrapartida")) {
        setCurrentStep(nextStep);
      }
    } else {
      // Si no hay validaciones específicas para este paso, permite el cambio
      setCurrentStep(nextStep);
    }
  };

  const renderProgressBar = (value) => {
    const porcentaje =
      totalProyecto > 0 ? ((value / totalProyecto) * 100).toFixed(2) : 0;
    return (
      <Progress
        percent={porcentaje}
        strokeColor="#1890ff"
        showInfo
        format={(percent) => `${percent}%`}
        status="active"
        style={{ width: "150px", marginLeft: "10px" }}
      />
    );
  };

  const handleCancel = () => {
    Modal.confirm({
      title: "¿Está segur@ de que desea cerrar?",
      content:
        "Si cierra esta ventana, la información ingresada no se guardará.",
      okText: "Sí, cerrar",
      cancelText: "No",
      onOk: () => setIsModalOpen(false), // Cierra el modal
    });
  };

  const validateFormListFields = (fieldName) => {
    const fieldValues = form.getFieldValue(fieldName);
    let isValid = true;

    if (!Array.isArray(fieldValues)) {
      return true;
    }

    // Campos que deben existir
    const requiredFields = [
      "descripcion",
      "recurso",
      "unidad",
      "cantidad",
      "valorUnitario",
    ];

    // Para detectar duplicados por OID
    const descripcionSet = new Set();

    fieldValues.forEach((item, index) => {
      if (!item) {
        isValid = false;
        return;
      }

      // Valida cada campo requerido
      requiredFields.forEach((field) => {
        if (
          item[field] === undefined ||
          item[field] === null ||
          item[field] === ""
        ) {
          isValid = false;
          form.validateFields([[fieldName, index, field]]);
        }
      });

      // Validación de duplicados usando item.descripcion (el OID)
      if (item.descripcion != null) {
        const key = item.descripcion.toString();

        const selectedProduct = productosMap[key];

        const productCode = selectedProduct
          ? selectedProduct.codigo
          : "Código desconocido";

        const already = descripcionSet.has(key);

        if (already) {
          isValid = false;
          message.error(
            `El producto "${productCode}" ya ha sido seleccionado.`
          );
        } else {
          descripcionSet.add(key);
        }
      } else {
        isValid = false;
      }
    });

    if (!isValid) {
      message.error(
        `Debe diligenciar todos los campos de ${fieldName} correctamente antes de continuar.`
      );
    }

    return isValid;
  };

  const calculateSubtotal = (fieldName) => {
    const fieldValues = form.getFieldValue(fieldName) || []; // Obtén los valores de la lista
    if (!Array.isArray(fieldValues)) {
      console.warn(`El campo ${fieldName} no contiene un array válido.`);
      return;
    }
    const subtotal = fieldValues.reduce(
      (acc, item) => acc + (item?.valorTotal || 0),
      0
    );
    setSubtotals((prev) => ({ ...prev, [fieldName]: subtotal }));
  };

  useEffect(() => {
    const totalProyectado = Object.values(subtotals).reduce(
      (acc, val) => acc + val,
      0
    );
    setProyectado(totalProyectado);
  }, [subtotals]);

  const generateJSON = () => {
    // Obtiene todos los valores del formulario
    const formValues = form.getFieldsValue(true); // Asegura obtener los valores completos

    const dataUser = usernameFromState.username; // Extraemos el valor directamente como string

    // Función para mapear los productos con la información adicional del servicio
    const mapItemsWithProductDetails = (items) => {
      return items.map((item) => {
        // item.descripcion contiene el OID del producto
        const prod = productosMap[item.descripcion] || {};

        return {
          // Metadatos del producto (vienen de la API)
          oidProducto: prod.oid ?? null,
          codigo: prod.codigo ?? "",
          oid_categoria: prod.oid_categoria ?? null,
          nombreCategoria: prod.nombreCategoria ?? "",
          nombre_producto: prod.nombre_producto ?? "",
          descripcion_producto: prod.descripcion_producto ?? "",
          oid_unidad_medida: prod.oid_unidad_medida ?? null,
          nombreUnidadMedida: prod.nombreUnidadMedida ?? "",
          precio_unitarioPesos: (prod.precio_unitarioPesos ?? "0").toString(),
          precio_usd: (prod.precio_usd ?? "0").toString(),
          clasificacion: prod.clasificacion ?? "",
          simbolo_proyecto: prod.simbolo_proyecto ?? "",
          oid_fin_tipoProducto: prod.oid_fin_tipoProducto ?? null,
          nombreTipoProducto: prod.nombreTipoProducto ?? "",
          unidad_tecnica: prod.unidad_tecnica ?? "",
          estado: prod.estado ?? "Activo",

          // Valores que el usuario editó en el formulario
          recurso: item.recurso ?? "",
          cantidad: item.cantidad ?? 0,
          unidad: item.unidad ?? "",
          valorUnitario: Number(
            parseFloat(
              item.valorUnitario ?? item.precio_unitarioPesos ?? 0
            ).toFixed(2)
          ),
          valorTotal: Number(parseFloat(item.valorTotal ?? 0).toFixed(2)),
        };
      });
    };

    // Estructura los datos de cada sección con los detalles del producto
    const dataItems = [
      {
        title: "A. Infraestructura",
        items: mapItemsWithProductDetails(
          formValues.infraestructura,
          "infraestructura"
        ),
      },
      {
        title: "B. Activos Productivos y equipos",
        items: mapItemsWithProductDetails(formValues.activos, "activos"),
      },
      {
        title: "C. Herramientas y Mobiliario",
        items: mapItemsWithProductDetails(
          formValues.herramientas,
          "herramientas"
        ),
      },
      {
        title: "D. Insumos",
        items: mapItemsWithProductDetails(formValues.insumos, "insumos"),
      },
      {
        title: "E. Gastos Operativos",
        items: mapItemsWithProductDetails(formValues.gastos, "gastos"),
      },
      {
        title: "F. Contrapartida",
        items: mapItemsWithProductDetails(
          formValues.contrapartida,
          "contrapartida"
        ),
      },
    ];

    // Calcula el resumen del concepto de inversión
    const totalProyectado = Object.values(subtotals).reduce(
      (acc, val) => acc + val,
      0
    );
    const conceptoInversion = [
      {
        concepto: "A. Infraestructura",
        valor: subtotals.infraestructura,
        porcentaje:
          ((subtotals.infraestructura / totalProyectado) * 100).toFixed(2) +
          "%",
      },
      {
        concepto: "B. Activos Productivos y equipos",
        valor: subtotals.activos,
        porcentaje:
          ((subtotals.activos / totalProyectado) * 100).toFixed(2) + "%",
      },
      {
        concepto: "C. Herramientas y Mobiliario",
        valor: subtotals.herramientas,
        porcentaje:
          ((subtotals.herramientas / totalProyectado) * 100).toFixed(2) + "%",
      },
      {
        concepto: "D. Insumos",
        valor: subtotals.insumos,
        porcentaje:
          ((subtotals.insumos / totalProyectado) * 100).toFixed(2) + "%",
      },
      {
        concepto: "E. Gastos Operativos",
        valor: subtotals.gastos,
        porcentaje:
          ((subtotals.gastos / totalProyectado) * 100).toFixed(2) + "%",
      },
      {
        concepto: "F. Contrapartida",
        valor: subtotals.contrapartida,
        porcentaje:
          ((subtotals.contrapartida / totalProyectado) * 100).toFixed(2) + "%",
      },
      {
        concepto: "TOTAL PROYECTO",
        valor: totalProyectado,
        porcentaje: "100%",
      },
    ];

    // Estructura final del JSON
    const finalJSON = {
      user: dataUser,
      codSir: formValues.codSir || [], // Captura los valores seleccionados en codSir
      dataItems: dataItems,
      conceptoInversion: conceptoInversion,
    };

    return finalJSON;
  };

  // Función para mostrar modales de confirmación, éxito o error
  const showModalFinish = (type, title, content, onOk = null) => {
    Modal[type]({
      title,
      content,
      okText: "Aceptar", // ✅ Solo el botón "Aceptar"
      cancelText: null, // ✅ Sin botón de cancelar
      onOk: onOk || (() => {}), // ✅ Ejecuta `onOk` si se pasa una función
    });
  };

  const handleFinalizar = async () => {
    showModalFinish(
      "confirm",
      "¿Está segur@ de finalizar?",
      "Una vez registrado el Plan de Compras - PAATI, no podrá editar esta información.",
      async () => {
        setLoading(true);

        const generatedJSON = generateJSON();

        try {
          let response;

          if (currentPlan && currentPlan.oid) {
            response = await actualizarPlanCompra(
              currentPlan.oid,
              generatedJSON,
              initialData
            );
          } else {
            response = await registrarPlanCompra(generatedJSON);
          }

          if (response.status === 200 || response.status === 201) {
            // 🔹 Asegurar que obtenemos los datos actualizados antes de cerrar el modal
            await fetchPlanes();
            showModalFinish(
              "success",
              currentPlan
                ? "Plan de Compras Actualizado"
                : "Plan de Compras Registrado",
              `El Plan de Compras - PAATI ha sido ${
                currentPlan ? "actualizado" : "guardado"
              } exitosamente.`,
              () => {
                setIsModalOpen(false);
                setCurrentPlan(null);
              }
            );
          } else {
            console.error("⚠️ Error en la respuesta del servidor:", response);
            showModalFinish(
              "error",
              "Error en el Registro",
              `Hubo un problema al ${
                currentPlan ? "actualizar" : "registrar"
              } el Plan de Compras - PAATI. Intente nuevamente.`
            );
          }
        } catch (error) {
          console.error("❌ Error en la conexión con el servidor:", error);
          showModalFinish(
            "error",
            "Error de Conexión",
            "No se pudo conectar con el servidor. Verifique su conexión e intente nuevamente."
          );
        } finally {
          setLoading(false);
        }
      }
    );
  };

  // 🔄 Cargar datos iniciales cuando cambia `planes`
  useEffect(() => {
    setFilteredPlanes(planes); // Sincroniza `filteredPlanes` con `planes`
  }, [planes]);

  const filtrarPlanes = () => {
    let resultado = [...planes];

    // 1. Filtrar por texto código SIR
    if (searchText.trim() !== "") {
      resultado = resultado.filter((plan) =>
        plan.codSir.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    // 2. Filtrar por estado de Aceptación
    if (selectedFiltersAceptacion.length > 0) {
      resultado = resultado.filter((plan) => {
        // Determinar el estado string según tu lógica de render
        let estadoAceptacion;
        if (plan.tiene_aceptacion === 0) {
          estadoAceptacion = "sin_registrar";
        } else if (plan.estado_aceptacion === 0) {
          estadoAceptacion = "registrado_sin_firma";
        } else if (plan.estado_aceptacion === 1) {
          estadoAceptacion = "registrado_con_firma";
        } else {
          // Por si acaso hay otro caso (null / undefined)
          return false;
        }
        return selectedFiltersAceptacion.includes(estadoAceptacion);
      });
    }

    // 3. Filtrar por estado de Delegación (misma estructura de lógica)
    if (selectedFiltersDelegacion.length > 0) {
      resultado = resultado.filter((plan) => {
        let estadoDelegacion;
        if (plan.tiene_delegacion === 0) {
          estadoDelegacion = "sin_registrar";
        } else if (plan.estado_delegacion === 0) {
          estadoDelegacion = "registrado_sin_firma";
        } else if (plan.estado_delegacion === 1) {
          estadoDelegacion = "registrado_con_firma";
        } else {
          return false;
        }
        return selectedFiltersDelegacion.includes(estadoDelegacion);
      });
    }

    // 4. Filtrar por departamento
    if (selectedDepartamento) {
      resultado = resultado.filter(
        (plan) => plan.departamento === selectedDepartamento
      );
    }

    // 5. Filtrar por municipio
    if (selectedMunicipio) {
      resultado = resultado.filter(
        (plan) => plan.municipio === selectedMunicipio
      );
    }

    setFilteredPlanes(resultado);
  };

  useEffect(() => {
    filtrarPlanes();
  }, [
    searchText,
    selectedFiltersAceptacion,
    selectedFiltersDelegacion,
    selectedDepartamento,
    selectedMunicipio,
  ]);

  const totalProyecto = Object.values(totals).reduce(
    (acc, val) => acc + val,
    0
  );

  // Devuelve departamentos únicos
  const getDepartamentosUnicos = () => {
    const departamentos = planes
      .map((plan) => plan.departamento)
      .filter(Boolean);
    return [...new Set(departamentos)];
  };

  // Devuelve municipios únicos del departamento seleccionado
  const getMunicipiosUnicos = (departamento) => {
    if (!departamento) return [];
    const municipios = planes
      .filter((plan) => plan.departamento === departamento)
      .map((plan) => plan.municipio)
      .filter(Boolean);
    return [...new Set(municipios)];
  };

  if (!planes || planes.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
        <p style={{ marginTop: 16, fontSize: 16, color: "#888" }}>
          Cargando datos...
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="container mt-4">
        <Header166 type="pl" />

        <Row gutter={[16, 16]} style={{ marginBottom: "16px" }} align="middle">
          <Col xs={24} sm={12} md={8} lg={6} xl={3}>
            <Select
              placeholder="Departamento"
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="children" // busca dentro del texto de las opciones
              value={selectedDepartamento}
              allowClear
              onChange={(value) => {
                setSelectedDepartamento(value);
                setSelectedMunicipio(null); // Limpiar municipio al cambiar departamento
              }}
              options={getDepartamentosUnicos().map((dep) => ({
                value: dep,
                label: dep,
              }))}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={3}>
            <Select
              placeholder="Municipio"
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="children" // busca dentro del texto de las opciones
              value={selectedMunicipio}
              allowClear
              onChange={setSelectedMunicipio}
              disabled={!selectedDepartamento}
              options={getMunicipiosUnicos(selectedDepartamento).map((mun) => ({
                value: mun,
                label: mun,
              }))}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <Input
              placeholder="Código SIR"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              prefix={<SearchOutlined />}
              allowClear
              style={{ width: "100%" }}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <Select
              mode="multiple"
              placeholder="Estado aceptación"
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="children" // busca dentro del texto de las opciones
              value={selectedFiltersAceptacion}
              options={estados}
              allowClear
              optionLabelProp="label"
              onChange={setSelectedFiltersAceptacion}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <Select
              mode="multiple"
              placeholder="Estado delegación"
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="children" // busca dentro del texto de las opciones
              value={selectedFiltersDelegacion}
              options={estados}
              allowClear
              optionLabelProp="label"
              onChange={setSelectedFiltersDelegacion}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={1}>
            <Tooltip title="Limpiar filtros">
              <Button
                icon={<ClearOutlined />}
                onClick={() => {
                  setSearchText("");
                  setSelectedFiltersAceptacion([]);
                  setSelectedFiltersDelegacion([]);
                  setSelectedDepartamento(null);
                  setSelectedMunicipio(null);
                  setFilteredPlanes(planes); // Actualiza la data mostrada
                }}
              />
            </Tooltip>
          </Col>

          {permissionInsert && (
            <Col xs={24} sm={12} md={8} lg={6} xl={2}>
              <Tooltip title="Agregar plan de compras">
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={handleCreate}
                  style={{ width: "100%" }}
                >
                  Nuevo
                </Button>
              </Tooltip>
            </Col>
          )}

          {/* Total */}
          <Col xs={24} sm={12} md={8} lg={6} xl={3}>
            <Card
              size="small"
              style={{
                marginTop: "24px",
                textAlign: "center",
                backgroundColor: "#f0f5ff", // Fondo azul claro
              }}
            >
              <Statistic
                title="Total Registros"
                value={filteredPlanes.length}
                valueStyle={{
                  color: "#1890ff",
                  fontWeight: "bold",
                }}
              />
            </Card>
          </Col>
        </Row>

        <div className="row mb-4">
          <div className="col-12">
            {filteredPlanes.length > 0 ? (
              <Table
                columns={columns}
                dataSource={filteredPlanes} // Ahora siempre tendrá datos correctos
                loading={loading}
                rowKey="oid"
                bordered
                pagination={{
                  current: currentPage, // página actual
                  pageSize: pageSize, // filas por página
                  total: filteredPlanes.length, // total de registros
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "50", "100"],
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} de ${total} registros`,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
                scroll={{ y: 500, x: "max-content" }}
                footer={() => (
                  <div
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      padding: "10px 0",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      <span>
                        Total Infraestructura:{" "}
                        {totals.infraestructura.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </span>
                      {renderProgressBar(totals.infraestructura)}

                      <span>
                        Total Activos:{" "}
                        {totals.activos.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </span>
                      {renderProgressBar(totals.activos)}

                      <span>
                        Total Herramientas:{" "}
                        {totals.herramientas.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </span>
                      {renderProgressBar(totals.herramientas)}

                      <span>
                        Total Insumos:{" "}
                        {totals.insumos.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </span>
                      {renderProgressBar(totals.insumos)}

                      <span>
                        Total Gastos:{" "}
                        {totals.gastos.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </span>
                      {renderProgressBar(totals.gastos)}

                      <span>
                        Total Contrapartidas:{" "}
                        {totals.contrapartida.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </span>
                      {renderProgressBar(totals.contrapartida)}

                      <span style={{ color: "blue" }}>
                        TOTAL PROYECTOS:{" "}
                        {totals.total.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </span>
                    </div>
                  </div>
                )}
              />
            ) : (
              <div style={{ textAlign: "center", margin: "20px" }}>
                <Alert
                  message="No hay resultados"
                  description="No se encontraron planes de compra con tu búsqueda."
                  type="info"
                  showIcon
                />
              </div>
            )}
          </div>
        </div>

        {/* Modal con formulario wizard */}
        <Modal
          title="Plan de Compras - PAATI"
          open={isModalOpen}
          onCancel={handleCancel}
          footer={
            <div
              style={{
                textAlign: "center",
                padding: "10px 0px",
                fontSize: "14px",
                color: "gray",
              }}
            >
              No cierre esta ventana hasta finalizar todos los pasos, la
              información solo se guarda después de validar y finalizar todos
              los pasos.
            </div>
          }
          width="95%"
          styles={{
            body: {
              maxHeight: "80vh",
              overflowY: "auto",
              padding: "1px",
            },
            top: 20,
          }}
        >
          <div style={{ display: "flex", height: "100%" }}>
            {/* Panel de Steps */}
            <div
              style={{
                width: stepsVisible ? "25%" : "0",
                overflow: "hidden",
                borderRight: stepsVisible ? "1px solid #f0f0f0" : "none",
                padding: stepsVisible ? "16px 0px" : "0",
                transition: "width 0.3s",
              }}
            >
              {stepsVisible && (
                <Steps
                  direction="vertical"
                  current={currentStep}
                  onChange={(nextStep) => handleStepChange(nextStep)} // Reemplaza `setCurrentStep` con `handleStepChange`
                  items={steps.map((step) => ({ title: step.title }))}
                />
              )}
            </div>

            {/* Contenedor del formulario */}
            <div
              style={{
                flex: 1,
                padding: "16px",
                overflowY: "auto", // <-- Agregado para permitir desplazamiento vertical
                maxHeight: "70vh", // <-- Limita la altura del contenido
                transition: "all 0.3s ease",
              }}
            >
              {/* Botón para alternar el panel */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center", // Alinea verticalmente los elementos
                  justifyContent: "space-between",
                  gap: "16px", // Espaciado entre el botón y el texto
                  marginBottom: "16px",
                }}
              >
                <Button
                  type="primary"
                  icon={
                    stepsVisible ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />
                  }
                  onClick={toggleSteps}
                  style={{
                    zIndex: 10,
                    transition: "left 0.3s",
                  }}
                >
                  {stepsVisible ? "Ocultar" : "Mostrar"} Panel
                </Button>

                <h3 style={{ margin: 0 }}>
                  Asignación:{" "}
                  <span
                    style={{
                      color:
                        proyectado > presupuestoasignado ? "red" : "#198754",
                    }}
                  >
                    ${presupuestoasignado.toLocaleString("es-CO")}
                  </span>
                </h3>
                <h3 style={{ margin: 0 }}>
                  Proyectado:
                  <span
                    style={{
                      color:
                        proyectado > presupuestoasignado ? "red" : "#198754",
                    }}
                  >
                    {proyectado.toLocaleString("es-CO", {
                      style: "currency",
                      currency: "COP",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}
                  </span>
                </h3>
              </div>

              {/* Contenido dinámico del formulario */}
              <Form
                form={form}
                layout="vertical"
                initialValues={{
                  infraestructura: [],
                  activos: [],
                  herramientas: [],
                  insumos: [],
                  gastos: [],
                  contrapartida: [], // Asegurar que todas las secciones existan
                }}
                onValuesChange={(changedValues, allValues) => {
                  const [changedField] = Object.keys(changedValues);
                  if (changedField && subtotals.hasOwnProperty(changedField)) {
                    calculateSubtotal(changedField);
                  }
                }}
              >
                {currentStep === 0 && (
                  <div>
                    <h4
                      style={{
                        background: "#ced4da2b",
                        borderRadius: "10px",
                        paddingLeft: "5px",
                      }}
                    >
                      Seleccione uno o varios códigos SIR
                    </h4>
                    <Form.Item
                      name="codSir"
                      label="Código Sir"
                      rules={[
                        {
                          required: true,
                          message:
                            "Por favor seleccione uno o varios códigos SIR",
                        },
                        {
                          validator: (_, value) => {
                            if (
                              value &&
                              value.some((val) => !/^\d{2}-\d{5}$/.test(val))
                            ) {
                              return Promise.reject(
                                "Algunos códigos no tienen el formato correcto (e.g., 60-06548)"
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Select
                        mode="multiple"
                        showSearch
                        disabled={!!currentPlan}
                        placeholder="Seleccione los códigos SIR"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        loading={loading}
                        style={{ width: "100%" }}
                        options={participantes.map((p) => ({
                          value: p.value,
                          label: p.label,
                        }))} // 🔥 Solo enviamos `{ value, label }`
                        onChange={(value) => {
                          const presupuesto = value.length * 3000000;
                          setPresupuestoasignado(presupuesto);
                        }}
                      />
                    </Form.Item>
                  </div>
                )}

                {/* Aquí se incluyen los demás pasos del wizard */}
                {currentStep === 1 && (
                  <div>
                    <h3
                      style={{
                        background: "#ced4da2b",
                        borderRadius: "10px",
                        paddingLeft: "5px",
                      }}
                    >
                      A. Infraestructura
                    </h3>

                    <Form.List name="infraestructura">
                      {(fields, { add, remove }) => (
                        <>
                          {/* Encabezado de la tabla */}
                          {fields.length > 0 && (
                            <Row
                              gutter={16}
                              align="middle"
                              style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                              }}
                            >
                              <Col span={1}></Col>
                              <Col span={5}>Descripción *</Col>
                              <Col span={4}>Recurso ARN *</Col>
                              <Col span={3}>Unidad *</Col>
                              <Col span={3}>Cantidad *</Col>
                              <Col span={3}>V/Unitario *</Col>
                              <Col span={4}>Cofinanciación ARN</Col>
                              <Col span={1}></Col>
                            </Row>
                          )}

                          {fields.map(({ key, name, ...restField }) => {
                            // Obtener el valor actual de la fila
                            const infraestructuraValues =
                              form.getFieldValue("infraestructura") || [];
                            const currentProduct =
                              infraestructuraValues[name]?.descripcion;

                            // Si no encuentra el producto en `productosMap`, buscar en `infraestructuraValues`
                            const selectedProduct =
                              productosMap[currentProduct] ||
                              infraestructuraValues[name];

                            return (
                              <Row key={key} gutter={16} align="baseline">
                                {/* Botón con lupa - Solo se muestra si hay un producto seleccionado */}
                                <Col
                                  span={1}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  {currentProduct && (
                                    <Button
                                      type="link"
                                      icon={<FileSearchOutlined />}
                                      onClick={() =>
                                        showProductDetails(selectedProduct)
                                      }
                                      style={{ fontSize: "23px" }}
                                    />
                                  )}
                                </Col>

                                {/* Descripción */}
                                <Col span={5}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "descripcion"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Seleccione un producto",
                                      },
                                    ]}
                                  >
                                    <Select
                                      showSearch
                                      placeholder="Seleccione un producto"
                                      optionFilterProp="label"
                                      optionLabelProp="label"
                                      notFoundContent={
                                        loading ? <Spin size="small" /> : null
                                      }
                                      options={productosPAATY}
                                      onChange={(value) => {
                                        // Buscar el producto en `productosMap`
                                        const selectedProduct =
                                          productosMap[value]; // Usar el value como clave en productosMap

                                        if (selectedProduct) {
                                          const updatedValues =
                                            form.getFieldValue(
                                              "infraestructura"
                                            ) || [];
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            descripcion: value, // Mantener la descripción como código - producto para la UI
                                            unidad:
                                              selectedProduct.nombreUnidadMedida,
                                            valorUnitario: parseFloat(
                                              selectedProduct.precio_unitarioPesos
                                            ),
                                            valorTotal: updatedValues[name]
                                              ?.cantidad
                                              ? parseFloat(
                                                  selectedProduct.precio_unitarioPesos
                                                ) *
                                                updatedValues[name]?.cantidad
                                              : 0,
                                          };

                                          form.setFieldsValue({
                                            infraestructura: updatedValues,
                                          });

                                          // Actualizar subtotal
                                          calculateSubtotal("infraestructura");

                                          // Guardar el producto seleccionado en estado (si lo usas en otro lugar)
                                          setSelectedProductDetails(
                                            selectedProduct
                                          );
                                        } else {
                                          console.warn(
                                            "⚠️ Producto no encontrado en productosMap"
                                          );
                                        }
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Recurso ARN */}
                                <Col span={4}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "recurso"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Seleccione opción",
                                      },
                                    ]}
                                  >
                                    <Select placeholder="Seleccione Recurso ARN">
                                      <Select.Option value="Activos Productivos">
                                        Activos Productivos
                                      </Select.Option>
                                      <Select.Option value="Proceso de Certificación y Permisos">
                                        Proceso de Certificación y Permisos
                                      </Select.Option>
                                      <Select.Option value="Estrategias de Mercadeo y Comercialización">
                                        Estrategias de Mercadeo y
                                        Comercialización
                                      </Select.Option>
                                      <Select.Option value="Procesos de Transformación y Valor Agregado">
                                        Procesos de Transformación y Valor
                                        Agregado
                                      </Select.Option>
                                      <Select.Option value="Innovación Tecnológica">
                                        Innovación Tecnológica
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>

                                {/* Unidad (Solo Lectura) */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "unidad"]}
                                  >
                                    <Input placeholder="Unidad" readOnly />
                                  </Form.Item>
                                </Col>

                                {/* Cantidad */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "cantidad"]}
                                  >
                                    <InputNumber
                                      placeholder="Cantidad"
                                      style={{ width: "100%" }}
                                      min={1}
                                      onChange={(value) => {
                                        const updatedValues = [
                                          ...infraestructuraValues,
                                        ];
                                        const valorUnitario =
                                          updatedValues[name]?.valorUnitario ||
                                          0;
                                        updatedValues[name] = {
                                          ...updatedValues[name],
                                          cantidad: value,
                                          valorTotal: value * valorUnitario,
                                        };
                                        form.setFieldsValue({
                                          infraestructura: updatedValues,
                                        });
                                        calculateSubtotal("infraestructura");
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Valor Unitario (Solo Lectura) */}

                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "valorUnitario"]}
                                  >
                                    <InputNumber
                                      placeholder="Valor unitario"
                                      className="input-right-align"
                                      style={{ width: "100%" }}
                                      formatter={(value) =>
                                        new Intl.NumberFormat("es-CO", {
                                          style: "currency",
                                          currency: "COP",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                          .format(value || 0)
                                          .replace(/\s/g, "")
                                      }
                                      parser={(value) =>
                                        parseFloat(
                                          value
                                            .replace(/\./g, "")
                                            .replace(",", ".")
                                            .replace(/[^\d.-]/g, "")
                                        )
                                      }
                                      // 🔹 Calcula cuando cambia el valor unitario
                                      onChange={(value) => {
                                        const updatedValues = [
                                          ...infraestructuraValues,
                                        ];
                                        const currentItem =
                                          updatedValues[name] || {};

                                        const cantidad = parseFloat(
                                          currentItem.cantidad ?? 0
                                        );
                                        updatedValues[name] = {
                                          ...updatedValues[name],
                                          valorUnitario: value,
                                          valorTotal:
                                            parseFloat(value ?? 0) * cantidad,
                                        };

                                        form.setFieldsValue({
                                          infraestructura: updatedValues,
                                        });
                                        calculateSubtotal("infraestructura");
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Cofinanciación ARN (Total) */}
                                <Col span={4}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "valorTotal"]}
                                  >
                                    <InputNumber
                                      placeholder="Cofinanciación ARN"
                                      className="input-right-align"
                                      style={{ width: "100%" }}
                                      readOnly
                                      formatter={(value) =>
                                        new Intl.NumberFormat("es-CO", {
                                          style: "currency",
                                          currency: "COP",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                          .format(value || 0)
                                          .replace(/\s/g, "")
                                      }
                                      parser={(value) =>
                                        parseFloat(
                                          value
                                            .replace(/\./g, "")
                                            .replace(",", ".")
                                            .replace(/[^\d.-]/g, "")
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Botón de eliminar */}
                                <Col
                                  span={1}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Popconfirm
                                    title="¿Estás segur@ de eliminar este ítem?"
                                    onConfirm={() => {
                                      remove(name);
                                    }}
                                    okText="Sí"
                                    cancelText="No"
                                  >
                                    <Button
                                      type="primary"
                                      danger
                                      icon={<DeleteOutlined />}
                                    />
                                  </Popconfirm>
                                </Col>
                              </Row>
                            );
                          })}

                          <Form.Item>
                            <Button
                              type="dashed"
                              onClick={() => add()}
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar ítem
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>

                    <div>
                      <h6>
                        Subtotal Infraestructura:{" "}
                        {subtotals.infraestructura.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </h6>
                    </div>
                  </div>
                )}

                {currentStep === 2 && (
                  <div>
                    <h3
                      style={{
                        background: "#ced4da2b",
                        borderRadius: "10px",
                        paddingLeft: "5px",
                      }}
                    >
                      B. Activos Productivos y Equipos
                    </h3>

                    <Form.List name="activos">
                      {(fields, { add, remove }) => (
                        <>
                          {/* Encabezado de la tabla */}
                          {fields.length > 0 && (
                            <Row
                              gutter={16}
                              align="middle"
                              style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                              }}
                            >
                              <Col span={1}></Col>
                              <Col span={5}>Descripción *</Col>
                              <Col span={4}>Recurso ARN *</Col>
                              <Col span={3}>Unidad *</Col>
                              <Col span={3}>Cantidad *</Col>
                              <Col span={3}>V/Unitario *</Col>
                              <Col span={4}>Cofinanciación ARN</Col>
                              <Col span={1}></Col>
                            </Row>
                          )}

                          {fields.map(({ key, name, ...restField }) => {
                            // Obtener el valor actual de la fila
                            const activosValues =
                              form.getFieldValue("activos") || [];
                            const currentProduct =
                              activosValues[name]?.descripcion;

                            // Si no encuentra el producto en `productosMap`, buscar en `activosValues`
                            const selectedProduct =
                              productosMap[currentProduct] ||
                              activosValues[name];

                            return (
                              <Row key={key} gutter={16} align="baseline">
                                {/* Botón con lupa - Solo se muestra si hay un producto seleccionado */}
                                <Col
                                  span={1}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  {currentProduct && (
                                    <Button
                                      type="link"
                                      icon={<FileSearchOutlined />}
                                      onClick={() =>
                                        showProductDetails(selectedProduct)
                                      }
                                      style={{ fontSize: "23px" }}
                                    />
                                  )}
                                </Col>

                                {/* Descripción */}
                                <Col span={5}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "descripcion"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Seleccione un producto",
                                      },
                                    ]}
                                  >
                                    <Select
                                      showSearch
                                      placeholder="Seleccione un producto"
                                      optionFilterProp="label"
                                      optionLabelProp="label"
                                      notFoundContent={
                                        loading ? <Spin size="small" /> : null
                                      }
                                      options={productosPAATY}
                                      onChange={(value) => {
                                        // Buscar el producto en `productosMap`
                                        const selectedProduct =
                                          productosMap[value]; // Usar el value como clave en productosMap

                                        if (selectedProduct) {
                                          const updatedValues =
                                            form.getFieldValue("activos") || [];
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            descripcion: value, // Mantener la descripción como código - producto para la UI
                                            unidad:
                                              selectedProduct.nombreUnidadMedida,
                                            valorUnitario: parseFloat(
                                              selectedProduct.precio_unitarioPesos
                                            ),
                                            valorTotal: updatedValues[name]
                                              ?.cantidad
                                              ? parseFloat(
                                                  selectedProduct.precio_unitarioPesos
                                                ) *
                                                updatedValues[name]?.cantidad
                                              : 0,
                                          };

                                          form.setFieldsValue({
                                            activos: updatedValues,
                                          });

                                          // Actualizar subtotal
                                          calculateSubtotal("activos");

                                          // Guardar el producto seleccionado en estado (si lo usas en otro lugar)
                                          setSelectedProductDetails(
                                            selectedProduct
                                          );
                                        } else {
                                          console.warn(
                                            "⚠️ Producto no encontrado en productosMap"
                                          );
                                        }
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Recurso ARN */}
                                <Col span={4}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "recurso"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Seleccione opción",
                                      },
                                    ]}
                                  >
                                    <Select placeholder="Seleccione Recurso ARN">
                                      <Select.Option value="Activos Productivos">
                                        Activos Productivos
                                      </Select.Option>
                                      <Select.Option value="Proceso de Certificación y Permisos">
                                        Proceso de Certificación y Permisos
                                      </Select.Option>
                                      <Select.Option value="Estrategias de Mercadeo y Comercialización">
                                        Estrategias de Mercadeo y
                                        Comercialización
                                      </Select.Option>
                                      <Select.Option value="Procesos de Transformación y Valor Agregado">
                                        Procesos de Transformación y Valor
                                        Agregado
                                      </Select.Option>
                                      <Select.Option value="Innovación Tecnológica">
                                        Innovación Tecnológica
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>

                                {/* Unidad (Solo Lectura) */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "unidad"]}
                                  >
                                    <Input placeholder="Unidad" readOnly />
                                  </Form.Item>
                                </Col>

                                {/* Cantidad */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "cantidad"]}
                                  >
                                    <InputNumber
                                      placeholder="Cantidad"
                                      style={{ width: "100%" }}
                                      min={1}
                                      onChange={(value) => {
                                        const updatedValues = [
                                          ...activosValues,
                                        ];
                                        const valorUnitario =
                                          updatedValues[name]?.valorUnitario ||
                                          0;
                                        updatedValues[name] = {
                                          ...updatedValues[name],
                                          cantidad: value,
                                          valorTotal: value * valorUnitario,
                                        };
                                        form.setFieldsValue({
                                          activos: updatedValues,
                                        });
                                        calculateSubtotal("activos");
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Valor Unitario (Solo Lectura) */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "valorUnitario"]}
                                  >
                                    <InputNumber
                                      placeholder="Valor unitario"
                                      className="input-right-align"
                                      style={{ width: "100%" }}
                                      formatter={(value) =>
                                        new Intl.NumberFormat("es-CO", {
                                          style: "currency",
                                          currency: "COP",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                          .format(value || 0)
                                          .replace(/\s/g, "")
                                      }
                                      parser={(value) =>
                                        parseFloat(
                                          value
                                            .replace(/\./g, "")
                                            .replace(",", ".")
                                            .replace(/[^\d.-]/g, "")
                                        )
                                      }
                                      // 🔹 Calcula cuando cambia el valor unitario
                                      onChange={(value) => {
                                        const updatedValues = [
                                          ...activosValues,
                                        ];
                                        const currentItem =
                                          updatedValues[name] || {};

                                        const cantidad = parseFloat(
                                          currentItem.cantidad ?? 0
                                        );
                                        updatedValues[name] = {
                                          ...updatedValues[name],
                                          valorUnitario: value,
                                          valorTotal:
                                            parseFloat(value ?? 0) * cantidad,
                                        };

                                        form.setFieldsValue({
                                          activos: updatedValues,
                                        });
                                        calculateSubtotal("activos");
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Cofinanciación ARN (Total) */}
                                <Col span={4}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "valorTotal"]}
                                  >
                                    <InputNumber
                                      placeholder="Cofinanciación ARN"
                                      className="input-right-align"
                                      style={{ width: "100%" }}
                                      readOnly
                                      formatter={(value) =>
                                        new Intl.NumberFormat("es-CO", {
                                          style: "currency",
                                          currency: "COP",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                          .format(value || 0)
                                          .replace(/\s/g, "")
                                      }
                                      parser={(value) =>
                                        parseFloat(
                                          value
                                            .replace(/\./g, "")
                                            .replace(",", ".")
                                            .replace(/[^\d.-]/g, "")
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Botón de eliminar */}
                                <Col
                                  span={1}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Popconfirm
                                    title="¿Estás segur@ de eliminar este ítem?"
                                    onConfirm={() => {
                                      remove(name);
                                      calculateSubtotal("activos");
                                    }}
                                    okText="Sí"
                                    cancelText="No"
                                  >
                                    <Button
                                      type="primary"
                                      danger
                                      icon={<DeleteOutlined />}
                                    />
                                  </Popconfirm>
                                </Col>
                              </Row>
                            );
                          })}
                          <Form.Item>
                            <Button
                              type="dashed"
                              onClick={() => {
                                add();
                                calculateSubtotal("activos");
                              }}
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar ítem
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>

                    <div>
                      <h6>
                        Subtotal Activos Productivos y Equipos:{" "}
                        {subtotals.activos.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </h6>
                    </div>
                  </div>
                )}

                {currentStep === 3 && (
                  <div>
                    <h3
                      style={{
                        background: "#ced4da2b",
                        borderRadius: "10px",
                        paddingLeft: "5px",
                      }}
                    >
                      C. Herramientas y Mobiliario
                    </h3>

                    <Form.List name="herramientas">
                      {(fields, { add, remove }) => (
                        <>
                          {/* Encabezado de la tabla */}
                          {fields.length > 0 && (
                            <Row
                              gutter={16}
                              align="middle"
                              style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                              }}
                            >
                              <Col span={1}></Col>
                              <Col span={5}>Descripción *</Col>
                              <Col span={4}>Recurso ARN *</Col>
                              <Col span={3}>Unidad *</Col>
                              <Col span={3}>Cantidad *</Col>
                              <Col span={3}>V/Unitario *</Col>
                              <Col span={4}>Cofinanciación ARN</Col>
                              <Col span={1}></Col>
                            </Row>
                          )}

                          {fields.map(({ key, name, ...restField }) => {
                            // Obtener el valor actual de la fila
                            const herramientasValues =
                              form.getFieldValue("herramientas") || [];
                            const currentProduct =
                              herramientasValues[name]?.descripcion;

                            // Si no encuentra el producto en `productosMap`, buscar en `herramientasValues`
                            const selectedProduct =
                              productosMap[currentProduct] ||
                              herramientasValues[name];

                            return (
                              <Row key={key} gutter={16} align="baseline">
                                {/* Botón con lupa - Solo se muestra si hay un producto seleccionado */}
                                <Col
                                  span={1}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  {currentProduct && (
                                    <Button
                                      type="link"
                                      icon={<FileSearchOutlined />}
                                      onClick={() =>
                                        showProductDetails(selectedProduct)
                                      }
                                      style={{ fontSize: "23px" }}
                                    />
                                  )}
                                </Col>

                                {/* Descripción */}
                                <Col span={5}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "descripcion"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Seleccione un producto",
                                      },
                                    ]}
                                  >
                                    <Select
                                      showSearch
                                      placeholder="Seleccione un producto"
                                      optionFilterProp="label"
                                      optionLabelProp="label"
                                      notFoundContent={
                                        loading ? <Spin size="small" /> : null
                                      }
                                      options={productosPAATY}
                                      onChange={(value) => {
                                        // Buscar el producto en `productosMap`
                                        const selectedProduct =
                                          productosMap[value]; // Usar el value como clave en productosMap

                                        if (selectedProduct) {
                                          const updatedValues =
                                            form.getFieldValue(
                                              "herramientas"
                                            ) || [];
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            descripcion: value, // Mantener la descripción como código - producto para la UI
                                            unidad:
                                              selectedProduct.nombreUnidadMedida,
                                            valorUnitario: parseFloat(
                                              selectedProduct.precio_unitarioPesos
                                            ),
                                            valorTotal: updatedValues[name]
                                              ?.cantidad
                                              ? parseFloat(
                                                  selectedProduct.precio_unitarioPesos
                                                ) *
                                                updatedValues[name]?.cantidad
                                              : 0,
                                          };

                                          form.setFieldsValue({
                                            herramientas: updatedValues,
                                          });

                                          // Actualizar subtotal
                                          calculateSubtotal("herramientas");

                                          // Guardar el producto seleccionado en estado (si lo usas en otro lugar)
                                          setSelectedProductDetails(
                                            selectedProduct
                                          );
                                        } else {
                                          console.warn(
                                            "⚠️ Producto no encontrado en productosMap"
                                          );
                                        }
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Recurso ARN */}
                                <Col span={4}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "recurso"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Seleccione opción",
                                      },
                                    ]}
                                  >
                                    <Select placeholder="Seleccione Recurso ARN">
                                      <Select.Option value="Activos Productivos">
                                        Activos Productivos
                                      </Select.Option>
                                      <Select.Option value="Proceso de Certificación y Permisos">
                                        Proceso de Certificación y Permisos
                                      </Select.Option>
                                      <Select.Option value="Estrategias de Mercadeo y Comercialización">
                                        Estrategias de Mercadeo y
                                        Comercialización
                                      </Select.Option>
                                      <Select.Option value="Procesos de Transformación y Valor Agregado">
                                        Procesos de Transformación y Valor
                                        Agregado
                                      </Select.Option>
                                      <Select.Option value="Innovación Tecnológica">
                                        Innovación Tecnológica
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>

                                {/* Unidad (Solo Lectura) */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "unidad"]}
                                  >
                                    <Input placeholder="Unidad" readOnly />
                                  </Form.Item>
                                </Col>

                                {/* Cantidad */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "cantidad"]}
                                  >
                                    <InputNumber
                                      placeholder="Cantidad"
                                      style={{ width: "100%" }}
                                      min={1}
                                      onChange={(value) => {
                                        const updatedValues = [
                                          ...herramientasValues,
                                        ];
                                        const valorUnitario =
                                          updatedValues[name]?.valorUnitario ||
                                          0;
                                        updatedValues[name] = {
                                          ...updatedValues[name],
                                          cantidad: value,
                                          valorTotal: value * valorUnitario,
                                        };
                                        form.setFieldsValue({
                                          herramientas: updatedValues,
                                        });
                                        calculateSubtotal("herramientas");
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Valor Unitario (Solo Lectura) */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "valorUnitario"]}
                                  >
                                    <InputNumber
                                      placeholder="Valor unitario"
                                      className="input-right-align"
                                      style={{ width: "100%" }}
                                      formatter={(value) =>
                                        new Intl.NumberFormat("es-CO", {
                                          style: "currency",
                                          currency: "COP",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                          .format(value || 0)
                                          .replace(/\s/g, "")
                                      }
                                      parser={(value) =>
                                        parseFloat(
                                          value
                                            .replace(/\./g, "")
                                            .replace(",", ".")
                                            .replace(/[^\d.-]/g, "")
                                        )
                                      }
                                      // 🔹 Calcula cuando cambia el valor unitario
                                      onChange={(value) => {
                                        const updatedValues = [
                                          ...herramientasValues,
                                        ];
                                        const currentItem =
                                          updatedValues[name] || {};

                                        const cantidad = parseFloat(
                                          currentItem.cantidad ?? 0
                                        );
                                        updatedValues[name] = {
                                          ...updatedValues[name],
                                          valorUnitario: value,
                                          valorTotal:
                                            parseFloat(value ?? 0) * cantidad,
                                        };

                                        form.setFieldsValue({
                                          herramientas: updatedValues,
                                        });
                                        calculateSubtotal("herramientas");
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Cofinanciación ARN (Total) */}
                                <Col span={4}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "valorTotal"]}
                                  >
                                    <InputNumber
                                      placeholder="Cofinanciación ARN"
                                      className="input-right-align"
                                      style={{ width: "100%" }}
                                      readOnly
                                      formatter={(value) =>
                                        new Intl.NumberFormat("es-CO", {
                                          style: "currency",
                                          currency: "COP",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                          .format(value || 0)
                                          .replace(/\s/g, "")
                                      }
                                      parser={(value) =>
                                        parseFloat(
                                          value
                                            .replace(/\./g, "")
                                            .replace(",", ".")
                                            .replace(/[^\d.-]/g, "")
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Botón de eliminar */}
                                <Col
                                  span={1}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Popconfirm
                                    title="¿Estás segur@ de eliminar este ítem?"
                                    onConfirm={() => {
                                      remove(name);
                                      calculateSubtotal("herramientas");
                                    }}
                                    okText="Sí"
                                    cancelText="No"
                                  >
                                    <Button
                                      type="primary"
                                      danger
                                      icon={<DeleteOutlined />}
                                    />
                                  </Popconfirm>
                                </Col>
                              </Row>
                            );
                          })}
                          <Form.Item>
                            <Button
                              type="dashed"
                              onClick={() => {
                                add();
                                calculateSubtotal("herramientas");
                              }}
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar ítem
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>

                    <div>
                      <h6>
                        Subtotal Herramientas y Mobiliario:{" "}
                        {subtotals.herramientas.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </h6>
                    </div>
                  </div>
                )}

                {currentStep === 4 && (
                  <div>
                    <h3
                      style={{
                        background: "#ced4da2b",
                        borderRadius: "10px",
                        paddingLeft: "5px",
                      }}
                    >
                      D. Insumos
                    </h3>

                    <Form.List name="insumos">
                      {(fields, { add, remove }) => (
                        <>
                          {/* Encabezado de la tabla */}
                          {fields.length > 0 && (
                            <Row
                              gutter={16}
                              align="middle"
                              style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                              }}
                            >
                              <Col span={1}></Col>
                              <Col span={5}>Descripción *</Col>
                              <Col span={4}>Recurso ARN *</Col>
                              <Col span={3}>Unidad *</Col>
                              <Col span={3}>Cantidad *</Col>
                              <Col span={3}>V/Unitario *</Col>
                              <Col span={4}>Cofinanciación ARN</Col>
                              <Col span={1}></Col>
                            </Row>
                          )}

                          {fields.map(({ key, name, ...restField }) => {
                            // Obtener el valor actual de la fila
                            const insumosValues =
                              form.getFieldValue("insumos") || [];
                            const currentProduct =
                              insumosValues[name]?.descripcion;

                            // Si no encuentra el producto en `productosMap`, buscar en `insumosValues`
                            const selectedProduct =
                              productosMap[currentProduct] ||
                              insumosValues[name];

                            return (
                              <Row key={key} gutter={16} align="baseline">
                                {/* Botón con lupa - Solo se muestra si hay un producto seleccionado */}
                                <Col
                                  span={1}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  {currentProduct && (
                                    <Button
                                      type="link"
                                      icon={<FileSearchOutlined />}
                                      onClick={() =>
                                        showProductDetails(selectedProduct)
                                      }
                                      style={{ fontSize: "23px" }}
                                    />
                                  )}
                                </Col>

                                {/* Descripción */}
                                <Col span={5}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "descripcion"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Seleccione un producto",
                                      },
                                    ]}
                                  >
                                    <Select
                                      showSearch
                                      placeholder="Seleccione un producto"
                                      optionFilterProp="label"
                                      optionLabelProp="label"
                                      notFoundContent={
                                        loading ? <Spin size="small" /> : null
                                      }
                                      options={productosPAATY}
                                      onChange={(value) => {
                                        // Buscar el producto en `productosMap`
                                        const selectedProduct =
                                          productosMap[value]; // Usar el value como clave en productosMap

                                        if (selectedProduct) {
                                          const updatedValues =
                                            form.getFieldValue("insumos") || [];
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            descripcion: value, // Mantener la descripción como código - producto para la UI
                                            unidad:
                                              selectedProduct.nombreUnidadMedida,
                                            valorUnitario: parseFloat(
                                              selectedProduct.precio_unitarioPesos
                                            ),
                                            valorTotal: updatedValues[name]
                                              ?.cantidad
                                              ? parseFloat(
                                                  selectedProduct.precio_unitarioPesos
                                                ) *
                                                updatedValues[name]?.cantidad
                                              : 0,
                                          };

                                          form.setFieldsValue({
                                            insumos: updatedValues,
                                          });

                                          // Actualizar subtotal
                                          calculateSubtotal("insumos");

                                          // Guardar el producto seleccionado en estado (si lo usas en otro lugar)
                                          setSelectedProductDetails(
                                            selectedProduct
                                          );
                                        } else {
                                          console.warn(
                                            "⚠️ Producto no encontrado en productosMap"
                                          );
                                        }
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Recurso ARN */}
                                <Col span={4}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "recurso"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Seleccione opción",
                                      },
                                    ]}
                                  >
                                    <Select placeholder="Seleccione Recurso ARN">
                                      <Select.Option value="Activos Productivos">
                                        Activos Productivos
                                      </Select.Option>
                                      <Select.Option value="Proceso de Certificación y Permisos">
                                        Proceso de Certificación y Permisos
                                      </Select.Option>
                                      <Select.Option value="Estrategias de Mercadeo y Comercialización">
                                        Estrategias de Mercadeo y
                                        Comercialización
                                      </Select.Option>
                                      <Select.Option value="Procesos de Transformación y Valor Agregado">
                                        Procesos de Transformación y Valor
                                        Agregado
                                      </Select.Option>
                                      <Select.Option value="Innovación Tecnológica">
                                        Innovación Tecnológica
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>

                                {/* Unidad (Solo Lectura) */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "unidad"]}
                                  >
                                    <Input placeholder="Unidad" readOnly />
                                  </Form.Item>
                                </Col>

                                {/* Cantidad */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "cantidad"]}
                                  >
                                    <InputNumber
                                      placeholder="Cantidad"
                                      style={{ width: "100%" }}
                                      min={1}
                                      onChange={(value) => {
                                        const updatedValues = [
                                          ...insumosValues,
                                        ];
                                        const valorUnitario =
                                          updatedValues[name]?.valorUnitario ||
                                          0;
                                        updatedValues[name] = {
                                          ...updatedValues[name],
                                          cantidad: value,
                                          valorTotal: value * valorUnitario,
                                        };
                                        form.setFieldsValue({
                                          insumos: updatedValues,
                                        });
                                        calculateSubtotal("insumos");
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Valor Unitario (Solo Lectura) */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "valorUnitario"]}
                                  >
                                    <InputNumber
                                      placeholder="Valor unitario"
                                      className="input-right-align"
                                      style={{ width: "100%" }}
                                      formatter={(value) =>
                                        new Intl.NumberFormat("es-CO", {
                                          style: "currency",
                                          currency: "COP",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                          .format(value || 0)
                                          .replace(/\s/g, "")
                                      }
                                      parser={(value) =>
                                        parseFloat(
                                          value
                                            .replace(/\./g, "")
                                            .replace(",", ".")
                                            .replace(/[^\d.-]/g, "")
                                        )
                                      }
                                      onChange={(value) => {
                                        const updatedValues = [
                                          ...insumosValues,
                                        ];
                                        const currentItem =
                                          updatedValues[name] || {};

                                        const cantidad = parseFloat(
                                          currentItem.cantidad ?? 0
                                        );
                                        updatedValues[name] = {
                                          ...updatedValues[name],
                                          valorUnitario: value,
                                          valorTotal:
                                            parseFloat(value ?? 0) * cantidad,
                                        };

                                        form.setFieldsValue({
                                          insumos: updatedValues,
                                        });
                                        calculateSubtotal("insumos");
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Cofinanciación ARN (Total) */}
                                <Col span={4}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "valorTotal"]}
                                  >
                                    <InputNumber
                                      placeholder="Cofinanciación ARN"
                                      className="input-right-align"
                                      style={{ width: "100%" }}
                                      readOnly
                                      formatter={(value) =>
                                        new Intl.NumberFormat("es-CO", {
                                          style: "currency",
                                          currency: "COP",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                          .format(value || 0)
                                          .replace(/\s/g, "")
                                      }
                                      parser={(value) =>
                                        parseFloat(
                                          value
                                            .replace(/\./g, "")
                                            .replace(",", ".")
                                            .replace(/[^\d.-]/g, "")
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Botón de eliminar */}
                                <Col
                                  span={1}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Popconfirm
                                    title="¿Estás segur@ de eliminar este ítem?"
                                    onConfirm={() => {
                                      remove(name);
                                      calculateSubtotal("insumos");
                                    }}
                                    okText="Sí"
                                    cancelText="No"
                                  >
                                    <Button
                                      type="primary"
                                      danger
                                      icon={<DeleteOutlined />}
                                    />
                                  </Popconfirm>
                                </Col>
                              </Row>
                            );
                          })}
                          <Form.Item>
                            <Button
                              type="dashed"
                              onClick={() => {
                                add();
                                calculateSubtotal("insumos");
                              }}
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar ítem
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>

                    <div>
                      <h6>
                        Subtotal Insumos:{" "}
                        {subtotals.insumos.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </h6>
                    </div>
                  </div>
                )}

                {currentStep === 5 && (
                  <div>
                    <h3
                      style={{
                        background: "#ced4da2b",
                        borderRadius: "10px",
                        paddingLeft: "5px",
                      }}
                    >
                      E. Gastos Operativos
                    </h3>

                    <Form.List name="gastos">
                      {(fields, { add, remove }) => (
                        <>
                          {/* Encabezado de la tabla */}
                          {fields.length > 0 && (
                            <Row
                              gutter={16}
                              align="middle"
                              style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                              }}
                            >
                              <Col span={1}></Col>
                              <Col span={5}>Descripción *</Col>
                              <Col span={4}>Recurso ARN *</Col>
                              <Col span={3}>Unidad *</Col>
                              <Col span={3}>Cantidad *</Col>
                              <Col span={3}>V/Unitario *</Col>
                              <Col span={4}>Cofinanciación ARN</Col>
                              <Col span={1}></Col>
                            </Row>
                          )}

                          {fields.map(({ key, name, ...restField }) => {
                            // Obtener el valor actual de la fila
                            const gastosValues =
                              form.getFieldValue("gastos") || [];
                            const currentProduct =
                              gastosValues[name]?.descripcion;

                            // Si no encuentra el producto en `productosMap`, buscar en `gastosValues`
                            const selectedProduct =
                              productosMap[currentProduct] ||
                              gastosValues[name];

                            return (
                              <Row key={key} gutter={16} align="baseline">
                                {/* Botón con lupa - Solo se muestra si hay un producto seleccionado */}
                                <Col
                                  span={1}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  {currentProduct && (
                                    <Button
                                      type="link"
                                      icon={<FileSearchOutlined />}
                                      onClick={() =>
                                        showProductDetails(selectedProduct)
                                      }
                                      style={{ fontSize: "23px" }}
                                    />
                                  )}
                                </Col>

                                {/* Descripción */}
                                <Col span={5}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "descripcion"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Seleccione un producto",
                                      },
                                    ]}
                                  >
                                    <Select
                                      showSearch
                                      placeholder="Seleccione un producto"
                                      optionFilterProp="label"
                                      optionLabelProp="label"
                                      notFoundContent={
                                        loading ? <Spin size="small" /> : null
                                      }
                                      options={productosPAATY}
                                      onChange={(value) => {
                                        // Buscar el producto en `productosMap`
                                        const selectedProduct =
                                          productosMap[value]; // Usar el value como clave en productosMap

                                        if (selectedProduct) {
                                          const updatedValues =
                                            form.getFieldValue("gastos") || [];
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            descripcion: value, // Mantener la descripción como código - producto para la UI
                                            unidad:
                                              selectedProduct.nombreUnidadMedida,
                                            valorUnitario: parseFloat(
                                              selectedProduct.precio_unitarioPesos
                                            ),
                                            valorTotal: updatedValues[name]
                                              ?.cantidad
                                              ? parseFloat(
                                                  selectedProduct.precio_unitarioPesos
                                                ) *
                                                updatedValues[name]?.cantidad
                                              : 0,
                                          };

                                          form.setFieldsValue({
                                            gastos: updatedValues,
                                          });

                                          // Actualizar subtotal
                                          calculateSubtotal("gastos");

                                          // Guardar el producto seleccionado en estado (si lo usas en otro lugar)
                                          setSelectedProductDetails(
                                            selectedProduct
                                          );
                                        } else {
                                          console.warn(
                                            "⚠️ Producto no encontrado en productosMap"
                                          );
                                        }
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Recurso ARN */}
                                <Col span={4}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "recurso"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Seleccione opción",
                                      },
                                    ]}
                                  >
                                    <Select placeholder="Seleccione Recurso ARN">
                                      <Select.Option value="Activos Productivos">
                                        Activos Productivos
                                      </Select.Option>
                                      <Select.Option value="Proceso de Certificación y Permisos">
                                        Proceso de Certificación y Permisos
                                      </Select.Option>
                                      <Select.Option value="Estrategias de Mercadeo y Comercialización">
                                        Estrategias de Mercadeo y
                                        Comercialización
                                      </Select.Option>
                                      <Select.Option value="Procesos de Transformación y Valor Agregado">
                                        Procesos de Transformación y Valor
                                        Agregado
                                      </Select.Option>
                                      <Select.Option value="Innovación Tecnológica">
                                        Innovación Tecnológica
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>

                                {/* Unidad (Solo Lectura) */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "unidad"]}
                                  >
                                    <Input placeholder="Unidad" readOnly />
                                  </Form.Item>
                                </Col>

                                {/* Cantidad */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "cantidad"]}
                                  >
                                    <InputNumber
                                      placeholder="Cantidad"
                                      style={{ width: "100%" }}
                                      min={1}
                                      onChange={(value) => {
                                        const updatedValues = [...gastosValues];
                                        const valorUnitario =
                                          updatedValues[name]?.valorUnitario ||
                                          0;
                                        updatedValues[name] = {
                                          ...updatedValues[name],
                                          cantidad: value,
                                          valorTotal: value * valorUnitario,
                                        };
                                        form.setFieldsValue({
                                          gastos: updatedValues,
                                        });
                                        calculateSubtotal("gastos");
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Valor Unitario (Solo Lectura) */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "valorUnitario"]}
                                  >
                                    <InputNumber
                                      placeholder="Valor unitario"
                                      className="input-right-align"
                                      style={{ width: "100%" }}
                                      formatter={(value) =>
                                        new Intl.NumberFormat("es-CO", {
                                          style: "currency",
                                          currency: "COP",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                          .format(value || 0)
                                          .replace(/\s/g, "")
                                      }
                                      parser={(value) =>
                                        parseFloat(
                                          value
                                            .replace(/\./g, "")
                                            .replace(",", ".")
                                            .replace(/[^\d.-]/g, "")
                                        )
                                      }
                                      onChange={(value) => {
                                        const updatedValues = [...gastosValues];
                                        const currentItem =
                                          updatedValues[name] || {};

                                        const cantidad = parseFloat(
                                          currentItem.cantidad ?? 0
                                        );
                                        updatedValues[name] = {
                                          ...updatedValues[name],
                                          valorUnitario: value,
                                          valorTotal:
                                            parseFloat(value ?? 0) * cantidad,
                                        };

                                        form.setFieldsValue({
                                          gastos: updatedValues,
                                        });
                                        calculateSubtotal("gastos");
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Cofinanciación ARN (Total) */}
                                <Col span={4}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "valorTotal"]}
                                  >
                                    <InputNumber
                                      placeholder="Cofinanciación ARN"
                                      className="input-right-align"
                                      style={{ width: "100%" }}
                                      readOnly
                                      formatter={(value) =>
                                        new Intl.NumberFormat("es-CO", {
                                          style: "currency",
                                          currency: "COP",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                          .format(value || 0)
                                          .replace(/\s/g, "")
                                      }
                                      parser={(value) =>
                                        parseFloat(
                                          value
                                            .replace(/\./g, "")
                                            .replace(",", ".")
                                            .replace(/[^\d.-]/g, "")
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Botón de eliminar */}
                                <Col
                                  span={1}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Popconfirm
                                    title="¿Estás segur@ de eliminar este ítem?"
                                    onConfirm={() => {
                                      remove(name);
                                      calculateSubtotal("gastos");
                                    }}
                                    okText="Sí"
                                    cancelText="No"
                                  >
                                    <Button
                                      type="primary"
                                      danger
                                      icon={<DeleteOutlined />}
                                    />
                                  </Popconfirm>
                                </Col>
                              </Row>
                            );
                          })}
                          <Form.Item>
                            <Button
                              type="dashed"
                              onClick={() => {
                                add();
                                calculateSubtotal("gastos");
                              }}
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar ítem
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>

                    <div>
                      <h6>
                        Subtotal Gastos Operativos:{" "}
                        {subtotals.gastos.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </h6>
                    </div>
                  </div>
                )}

                {currentStep === 6 && (
                  <div>
                    <h3
                      style={{
                        background: "#ced4da2b",
                        borderRadius: "10px",
                        paddingLeft: "5px",
                      }}
                    >
                      F. Contrapartida
                    </h3>

                    <Form.List name="contrapartida">
                      {(fields, { add, remove }) => (
                        <>
                          {/* Encabezado de la tabla */}
                          {fields.length > 0 && (
                            <Row
                              gutter={16}
                              align="middle"
                              style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                              }}
                            >
                              <Col span={1}></Col>
                              <Col span={5}>Descripción *</Col>
                              <Col span={4}>Recurso ARN *</Col>
                              <Col span={3}>Unidad *</Col>
                              <Col span={3}>Cantidad *</Col>
                              <Col span={3}>V/Unitario *</Col>
                              <Col span={4}>Cofinanciación ARN</Col>
                              <Col span={1}></Col>
                            </Row>
                          )}

                          {fields.map(({ key, name, ...restField }) => {
                            // Obtener el valor actual de la fila
                            const contrapartidaValues =
                              form.getFieldValue("contrapartida") || [];
                            const currentProduct =
                              contrapartidaValues[name]?.descripcion;

                            // Si no encuentra el producto en `productosMap`, buscar en `contrapartidaValues`
                            const selectedProduct =
                              productosMap[currentProduct] ||
                              contrapartidaValues[name];

                            return (
                              <Row key={key} gutter={16} align="baseline">
                                {/* Botón con lupa - Solo se muestra si hay un producto seleccionado */}
                                <Col
                                  span={1}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  {currentProduct && (
                                    <Button
                                      type="link"
                                      icon={<FileSearchOutlined />}
                                      onClick={() =>
                                        showProductDetails(selectedProduct)
                                      }
                                      style={{ fontSize: "23px" }}
                                    />
                                  )}
                                </Col>

                                {/* Descripción */}
                                <Col span={5}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "descripcion"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Seleccione un producto",
                                      },
                                    ]}
                                  >
                                    <Select
                                      showSearch
                                      placeholder="Seleccione un producto"
                                      optionFilterProp="label"
                                      optionLabelProp="label"
                                      notFoundContent={
                                        loading ? <Spin size="small" /> : null
                                      }
                                      options={productosPAATY}
                                      onChange={(value) => {
                                        // Buscar el producto en `productosMap`
                                        const selectedProduct =
                                          productosMap[value]; // Usar el value como clave en productosMap

                                        if (selectedProduct) {
                                          const updatedValues =
                                            form.getFieldValue(
                                              "contrapartida"
                                            ) || [];
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            descripcion: value, // Mantener la descripción como código - producto para la UI
                                            unidad:
                                              selectedProduct.nombreUnidadMedida,
                                            valorUnitario: parseFloat(
                                              selectedProduct.precio_unitarioPesos
                                            ),
                                            valorTotal: updatedValues[name]
                                              ?.cantidad
                                              ? parseFloat(
                                                  selectedProduct.precio_unitarioPesos
                                                ) *
                                                updatedValues[name]?.cantidad
                                              : 0,
                                          };

                                          form.setFieldsValue({
                                            contrapartida: updatedValues,
                                          });

                                          // Actualizar subtotal
                                          calculateSubtotal("contrapartida");

                                          // Guardar el producto seleccionado en estado (si lo usas en otro lugar)
                                          setSelectedProductDetails(
                                            selectedProduct
                                          );
                                        } else {
                                          console.warn(
                                            "⚠️ Producto no encontrado en productosMap"
                                          );
                                        }
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Recurso ARN */}
                                <Col span={4}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "recurso"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Seleccione opción",
                                      },
                                    ]}
                                  >
                                    <Select placeholder="Seleccione Recurso ARN">
                                      <Select.Option value="Activos Productivos">
                                        Activos Productivos
                                      </Select.Option>
                                      <Select.Option value="Proceso de Certificación y Permisos">
                                        Proceso de Certificación y Permisos
                                      </Select.Option>
                                      <Select.Option value="Estrategias de Mercadeo y Comercialización">
                                        Estrategias de Mercadeo y
                                        Comercialización
                                      </Select.Option>
                                      <Select.Option value="Procesos de Transformación y Valor Agregado">
                                        Procesos de Transformación y Valor
                                        Agregado
                                      </Select.Option>
                                      <Select.Option value="Innovación Tecnológica">
                                        Innovación Tecnológica
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>

                                {/* Unidad (Solo Lectura) */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "unidad"]}
                                  >
                                    <Input placeholder="Unidad" readOnly />
                                  </Form.Item>
                                </Col>

                                {/* Cantidad */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "cantidad"]}
                                  >
                                    <InputNumber
                                      placeholder="Cantidad"
                                      style={{ width: "100%" }}
                                      min={1}
                                      onChange={(value) => {
                                        const updatedValues = [
                                          ...contrapartidaValues,
                                        ];
                                        const valorUnitario =
                                          updatedValues[name]?.valorUnitario ||
                                          0;
                                        updatedValues[name] = {
                                          ...updatedValues[name],
                                          cantidad: value,
                                          valorTotal: value * valorUnitario,
                                        };
                                        form.setFieldsValue({
                                          contrapartida: updatedValues,
                                        });
                                        calculateSubtotal("contrapartida");
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Valor Unitario (Solo Lectura) */}
                                <Col span={3}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "valorUnitario"]}
                                  >
                                    <InputNumber
                                      placeholder="Valor unitario"
                                      className="input-right-align"
                                      style={{ width: "100%" }}
                                      formatter={(value) =>
                                        new Intl.NumberFormat("es-CO", {
                                          style: "currency",
                                          currency: "COP",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                          .format(value || 0)
                                          .replace(/\s/g, "")
                                      }
                                      parser={(value) =>
                                        parseFloat(
                                          value
                                            .replace(/\./g, "")
                                            .replace(",", ".")
                                            .replace(/[^\d.-]/g, "")
                                        )
                                      }
                                      onChange={(value) => {
                                        const updatedValues = [
                                          ...contrapartidaValues,
                                        ];
                                        const currentItem =
                                          updatedValues[name] || {};

                                        const cantidad = parseFloat(
                                          currentItem.cantidad ?? 0
                                        );
                                        updatedValues[name] = {
                                          ...updatedValues[name],
                                          valorUnitario: value,
                                          valorTotal:
                                            parseFloat(value ?? 0) * cantidad,
                                        };

                                        form.setFieldsValue({
                                          contrapartida: updatedValues,
                                        });
                                        calculateSubtotal("contrapartida");
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Cofinanciación ARN (Total) */}
                                <Col span={4}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "valorTotal"]}
                                  >
                                    <InputNumber
                                      placeholder="Cofinanciación ARN"
                                      className="input-right-align"
                                      style={{ width: "100%" }}
                                      readOnly
                                      formatter={(value) =>
                                        new Intl.NumberFormat("es-CO", {
                                          style: "currency",
                                          currency: "COP",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                          .format(value || 0)
                                          .replace(/\s/g, "")
                                      }
                                      parser={(value) =>
                                        parseFloat(
                                          value
                                            .replace(/\./g, "")
                                            .replace(",", ".")
                                            .replace(/[^\d.-]/g, "")
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Botón de eliminar */}
                                <Col
                                  span={1}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Popconfirm
                                    title="¿Estás segur@ de eliminar este ítem?"
                                    onConfirm={() => {
                                      remove(name);
                                      calculateSubtotal("contrapartida");
                                    }}
                                    okText="Sí"
                                    cancelText="No"
                                  >
                                    <Button
                                      type="primary"
                                      danger
                                      icon={<DeleteOutlined />}
                                    />
                                  </Popconfirm>
                                </Col>
                              </Row>
                            );
                          })}
                          <Form.Item>
                            <Button
                              type="dashed"
                              onClick={() => {
                                add();
                                calculateSubtotal("contrapartida");
                              }}
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar ítem
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>

                    <div>
                      <h6>
                        Subtotal Contrapartida:{" "}
                        {subtotals.contrapartida.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        })}
                      </h6>
                    </div>
                  </div>
                )}

                {currentStep === 7 && (
                  <div>
                    <h3
                      style={{
                        background: "#ced4da2b",
                        borderRadius: "10px",
                        paddingLeft: "5px",
                      }}
                    >
                      Concepto de la inversión
                    </h3>
                    <Table
                      className="custom-table"
                      components={{
                        body: {
                          cell: (props) => (
                            <td {...props} style={{ textAlign: "center" }} />
                          ),
                        },
                      }}
                      dataSource={[
                        {
                          key: "1",
                          concepto: "A. Infraestructura",
                          valor: subtotals.infraestructura,
                          porcentaje:
                            (
                              (subtotals.infraestructura /
                                Object.values(subtotals).reduce(
                                  (acc, val) => acc + val,
                                  0
                                )) *
                              100
                            ).toFixed(2) + "%",
                        },
                        {
                          key: "2",
                          concepto: "B. Activos Productivos y equipos",
                          valor: subtotals.activos,
                          porcentaje:
                            (
                              (subtotals.activos /
                                Object.values(subtotals).reduce(
                                  (acc, val) => acc + val,
                                  0
                                )) *
                              100
                            ).toFixed(2) + "%",
                        },
                        {
                          key: "3",
                          concepto: "C. Herramientas y Mobiliario",
                          valor: subtotals.herramientas,
                          porcentaje:
                            (
                              (subtotals.herramientas /
                                Object.values(subtotals).reduce(
                                  (acc, val) => acc + val,
                                  0
                                )) *
                              100
                            ).toFixed(2) + "%",
                        },
                        {
                          key: "4",
                          concepto: "D. Insumos",
                          valor: subtotals.insumos,
                          porcentaje:
                            (
                              (subtotals.insumos /
                                Object.values(subtotals).reduce(
                                  (acc, val) => acc + val,
                                  0
                                )) *
                              100
                            ).toFixed(2) + "%",
                        },
                        {
                          key: "5",
                          concepto: "E. Gastos Operativos",
                          valor: subtotals.gastos,
                          porcentaje:
                            (
                              (subtotals.gastos /
                                Object.values(subtotals).reduce(
                                  (acc, val) => acc + val,
                                  0
                                )) *
                              100
                            ).toFixed(2) + "%",
                        },
                        {
                          key: "6",
                          concepto: "F. Contrapartida",
                          valor: subtotals.contrapartida,
                          porcentaje:
                            (
                              (subtotals.contrapartida /
                                Object.values(subtotals).reduce(
                                  (acc, val) => acc + val,
                                  0
                                )) *
                              100
                            ).toFixed(2) + "%",
                        },
                        {
                          key: "7",
                          concepto: "TOTAL PROYECTO",
                          valor: Object.values(subtotals).reduce(
                            (acc, val) => acc + val,
                            0
                          ),
                          porcentaje: "100%",
                        },
                      ]}
                      columns={[
                        {
                          title: (
                            <div
                              style={{
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              Concepto
                            </div>
                          ),
                          dataIndex: "concepto",
                          key: "concepto",
                        },
                        {
                          title: (
                            <div
                              style={{
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              Valor Cofinanciación y Contrapartida
                            </div>
                          ),
                          dataIndex: "valor",
                          key: "valor",
                          align: "right",
                          render: (value) =>
                            value.toLocaleString("es-CO", {
                              style: "currency",
                              currency: "COP",
                            }),
                        },
                        {
                          title: (
                            <div
                              style={{
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              % del total del proyecto
                            </div>
                          ),
                          dataIndex: "porcentaje",
                          key: "porcentaje",
                          align: "center",
                        },
                      ]}
                      pagination={false}
                      rowClassName={(record) =>
                        record.key === "7" ? "total-row" : ""
                      }
                      style={{
                        fontSize: "14px",
                        lineHeight: "1.2",
                        marginBottom: "20px",
                      }}
                    />
                    <style>
                      {`
        .ant-table-thead > tr > th {
            background-color: #f5f5f5;
            font-size: 14px;
            text-align: center;
            padding: 10px 10px !important;
        }
        .ant-table-row {
            font-size: 13px;
        }
        .ant-table-cell {
            padding: 10px 10px !important;
        }
        .total-row {
            font-weight: bold;
            background-color: #fafafa;
        }
    `}
                    </style>
                  </div>
                )}

                <div className="d-flex justify-content-between mt-4">
                  {currentStep > 0 && (
                    <Button onClick={prev} style={{ marginRight: "8px" }}>
                      Anterior
                    </Button>
                  )}

                  {currentStep < steps.length - 1 && (
                    <Button type="primary" onClick={next}>
                      Siguiente
                    </Button>
                  )}

                  {/* Botón "Finalizar" o mensaje de error */}
                  {currentStep === steps.length - 1 &&
                    (isExceeding ? (
                      <p style={{ color: "red", fontWeight: "bold" }}>
                        El formulario tiene errores: el monto proyectado excede
                        el presupuesto asignado.
                      </p>
                    ) : proyectado === 0 ? (
                      <p style={{ color: "red", fontWeight: "bold" }}>
                        El monto proyectado no puede ser cero. Por favor,
                        registre al menos un dato para continuar.
                      </p>
                    ) : (
                      <Button
                        type="primary"
                        onClick={handleFinalizar}
                        loading={loading}
                        disabled={loading} // Bloquea el botón cuando loading es true
                      >
                        {loading ? "Guardando..." : "Finalizar"}
                      </Button>
                    ))}
                </div>
              </Form>
            </div>
          </div>
        </Modal>

        {/* Modal de advertencia */}
        <Modal
          title="Advertencia: Presupuesto excedido"
          open={isModalVisible} // Controla la visibilidad del modal
          onOk={handleCloseModal}
          onCancel={handleCloseModal}
          okText="Entendido"
          cancelText="Cerrar"
        >
          <p>El valor proyectado no puede ser mayor que el valor asignado.</p>
          <p>
            <strong>Valor asignado:</strong>{" "}
            {presupuestoasignado.toLocaleString("es-CO", {
              style: "currency",
              currency: "COP",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}
          </p>
          <p>
            <strong>Valor proyectado:</strong>{" "}
            <span style={{ color: "red" }}>
              {proyectado.toLocaleString("es-CO", {
                style: "currency",
                currency: "COP",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </span>
          </p>
          <p>
            <strong>Exceso:</strong>{" "}
            <span style={{ color: "red" }}>
              {(proyectado - presupuestoasignado).toLocaleString("es-CO", {
                style: "currency",
                currency: "COP",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </span>
          </p>
        </Modal>

        {/* Modal para mostrar detalles del producto */}
        <Modal
          title={
            <span style={{ fontWeight: "bold", fontSize: "18px" }}>
              🛒 Detalles del Producto
            </span>
          }
          open={isModalVisibleP}
          onCancel={handleCloseModalP}
          footer={[
            <Button key="close" type="primary" onClick={handleCloseModalP}>
              Cerrar
            </Button>,
          ]}
        >
          {selectedProductDetails && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                fontSize: "16px",
              }}
            >
              {/* Producto */}
              <div>
                <Tag color="blue">Producto: </Tag>
                <span style={{ fontWeight: "bold" }}>
                  {" "}
                  {selectedProductDetails.nombre_producto}
                </span>
              </div>

              {/* Descripción */}
              <div>
                <Tag color="green">Descripción:</Tag>
                <span> {selectedProductDetails.descripcion_producto}</span>
              </div>

              {/* Precio COP */}
              <div>
                <Tag color="gold">Precio de referencia COP: </Tag>
                <span style={{ fontWeight: "bold", color: "#198754" }}>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(selectedProductDetails.precio_unitarioPesos)}
                </span>
              </div>

              {/* Precio USD */}
              <div>
                <Tag color="purple">Precio de referencia USD: </Tag>
                <span style={{ fontWeight: "bold", color: "#6f42c1" }}>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(selectedProductDetails.precio_usd)}
                </span>
              </div>

              {/* Unidad de medida */}
              <div>
                <Tag color="red">Unidad: </Tag>
                <span> {selectedProductDetails.nombreUnidadMedida}</span>
              </div>

              {/* Tipo */}
              <div>
                <Tag color="cyan">Categoría:</Tag>
                <span> {selectedProductDetails.nombreCategoria}</span>
              </div>

              {/* Fungible */}
              <div>
                <Tag color="magenta">Fungible /No Fungible:</Tag>
                <span> {selectedProductDetails.fungible}</span>
              </div>
            </div>
          )}
        </Modal>

        {/* Modal para mostrar detalles del plan de compras */}
        <Modal
          title={
            <span style={{ fontWeight: "bold", fontSize: "18px" }}>
              📄 Detalles del Plan de Compras
            </span>
          }
          open={isModalPreviewOpen}
          onCancel={handleClosePreview}
          footer={[
            <Button key="close" type="primary" onClick={handleClosePreview}>
              Cerrar
            </Button>,
          ]}
          style={{ top: 20 }}
        >
          {selectedPlan && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                fontSize: "16px",
              }}
            >
              {/* Usuario */}
              <div>
                <Tag color="blue">Usuario: </Tag>
                <span style={{ fontWeight: "bold" }}>{selectedPlan.user}</span>
              </div>

              {/* Código SIR */}
              <div>
                <Tag color="green">Código SIR:</Tag>
                <span>{selectedPlan.codSir}</span>
              </div>

              {/* Fecha de Creación */}
              <div>
                <Tag color="gold">Fecha de Creación:</Tag>
                <span>
                  {new Date(selectedPlan.fecha_creacion).toLocaleString(
                    "es-CO"
                  )}
                </span>
              </div>

              {/* Última Actualización */}
              <div>
                <Tag color="purple">Última Actualización:</Tag>
                <span>
                  {new Date(selectedPlan.fecha_actualizacion).toLocaleString(
                    "es-CO"
                  )}
                </span>
              </div>

              {/* Conceptos de Inversión */}
              <div>
                <h4>Conceptos de Inversión</h4>
                <Table
                  dataSource={selectedPlan.conceptoInversion}
                  pagination={false}
                  rowKey="concepto"
                  columns={[
                    {
                      title: "Concepto",
                      dataIndex: "concepto",
                      key: "concepto",
                    },
                    {
                      title: "Valor",
                      dataIndex: "valor",
                      key: "valor",
                      align: "right",
                      render: (value) =>
                        value.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                        }),
                    },
                    {
                      title: "% del Total",
                      dataIndex: "porcentaje",
                      key: "porcentaje",
                      align: "center",
                    },
                  ]}
                  bordered
                  size="small"
                />
              </div>
            </div>
          )}
        </Modal>
        <Drawer
          onClose={() => {
            setIsModalPreviewOpenFormatoAceptacion(false);
          }}
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                position: "relative",
              }}
            >
              <h6 style={{ margin: 0, fontWeight: "bold", paddingRight: 50 }}>
                Formatos
              </h6>

              <div>
                <Button
                  icon={<CloseOutlined />}
                  onClick={() => {
                    setIsModalPreviewOpenFormatoAceptacion(false);
                  }}
                  style={{
                    position: "absolute",
                    right: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    border: "none",
                    boxShadow: "none",
                  }}
                />
              </div>
            </div>
          }
          placement="right"
          open={isModalPreviewOpenFormatoAceptacion}
          width="100vw"
          style={{ height: "100vh", padding: 0 }}
        >
          <ListaDePlantillas
            key={Date.now()}
            idCurrentPlan={idcurrentPlan}
            updateData={fetchPlanes}
          />
        </Drawer>
      </div>
    </>
  );
};

export default PlanesCompras;
